import {GTM, GTM4N} from './gtm';
import Cookies from 'js-cookie';
import 'select2';
import 'select2/dist/js/i18n/uk';
import {U, __, WARNING, short_popup} from './global';
import {DRAWER} from "./drawer";
import {USER} from "./user";

export const CARD = {
    lead_id: 0,
    GA_data: {
        session_id: '',
        client_id: '',
    },
    promocode_loading: false,
    apple_merchant_id: G.portalid==7 ? 'merchant.oppoua.com' : 'merchant.ktc.ua',
    changegiftsku: 0,
    clickgopay: false,
    count_items: 0,
    current_step: 0,
    use_bonuses: 0,
    current_data: [],
    user_data: {
        name: '',
        email: '',
        phone: '',
    },
    items: {},
    total_overhead: 0,
    has_focus: 0,
    firstopened: false,
    onorderpage: false,
    second_step_error: '',
    payment_error_text: '',
    skip_delivery_step: false,
    sku_was_added: 0,
    slr_find_by_phone: false,
    sent_order_timeout: 35000,
    monobank_phone: '',
    abank_phone: '',
    sum: {
        uah: 0,
        usd: 0,
        paymentTotal: 0,
        deliveryTotal: 0
    },
    allow_bonuses: false,
    bonuses_entered: -1,
    bonus_opened: false,
    bonus_request_send: false,
    available_bonuses: {
        amount: 0,
        ts: 0
    },
    payment_data: {},
    force_update: 0,
    _update_payment_methods: true,
    payment_method: '',
    payment_method_data: {},
    timemout: false,
    timemoutSec: 500,
    timemoutId: false,
    wait_callback_time: 15,
    portmone_time: 60,
    monobank_time: 600,
    monobank_timeout_handler: false,
    monobank_process: false,
    creditchose_opened: false,
    more_functions_opened: false,
    novaposhta_timeout_handler: false,
    promocode: false,
    default_cities_added: false,
    searchcompany_type: 'UO',
    searchcompany_edrpou: '',
    searchcompany_address: '',
    _delivery_error_text: '',
    delivery: {},

    postData: async function (data = {}, url = '/aj', timeout = 10000) {

        data.locale = G.locale_id;
        data.page = document.location.pathname;
        data.mobile = (U.isMobile()?1:0);

        AbortSignal.timeout ??= function timeout(ms) {
            const ctrl = new AbortController()
            setTimeout(() => ctrl.abort(), ms)
            return ctrl.signal
        }

        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            signal: AbortSignal.timeout(timeout),
            body: new URLSearchParams(data)
        });
        return response.json(); // parses JSON response into native JavaScript objects
    },

    GA_client_id: function() {
        let res = this.GA_data.client_id;

        if (!res || res=='') {
            try {
                res = window.gaGlobal.vid;
            } catch(e){}
        }

        if (res==='undefined') {
            res = '';
        }

        return res;
    },

    submit_preorder: function() {
        this.load_GA_data();

        let btn = $(".js-preorder__submit, .js-preorder__submitcontinue");
        let form = $(".form-preorder");
        let name = form.find('[name=name]').val();
        let phone = form.find('[name=login]').val();
        let comment = form.find('[name=comment]').val();
        let sku = form.find('[name=sku]').val();
        let code = form.find('[name=code]').val();
        let qty = form.find('.cart__itemcount').data('val');

        if (btn.hasClass('loading')) {
            return;
        }

        form.find('.alert').addClass('hidden');
        btn.addClass('loading');

        return this.postData(
            {
                to: 'makepreorder',
                name,
                phone,
                comment,
                sku,
                code,
                qty,
                locale: G.locale_id,
                google_session: this.GA_data.session_id,
                google_client_id: this.GA_client_id()
            },
            '/u/makepreorder'
        ).then(data => {
            GTM.event('checkout_step', 1, 'Передзамовлення');
            GTM.event('purchase', data.order, data.products, 'Передзамовлення');

            CARD.send_GA(data.order.id, data.order.sum, 'preorder', data.products);
        }).finally(() => {
            btn.removeClass('loading');

            $(".workdrawer .content").html(`
                        <div class="exchange-thx"></div>
                        <div class="small-text text-center">Запит успішно надіслано</div>
                        <br /><br />
                        <button type="button" class="btn success js-closepopups mt16">Закрити</button>
                    `);

            setTimeout(() => {
                DRAWER.destroy();
            }, 5000);
        });
    },

    addFromMap: function(sku, city, warehouse) {
        return this.postData(
            {
                action: 'basket',
                to: 'addfrommap',
                sku,
                city,
                warehouse
            }
        );
    },

    add_bundle_to_cart: async function(btn) {
        return new Promise((resolve, reject) => {
            let sku_list = [];

            $.each(btn.parents('.bundle').find('.bundle__condition'), (i, _li) => {
                let li = $(_li);
                let price = li.find('.bundle__price');

                if (price.data('sku')) {
                    let sku = parseInt(price.data('sku'));

                    if (sku) {
                        sku_list.push(sku);

                        setTimeout(() => {
                            GTM.event('add_to_cart', price.data(), btn.data('list'), btn.data('listname'));
                            GTM.remarketing('cart', price.data(), btn.data('list'), btn.data('listname'));
                        }, 500);
                    }
                }
            });

            if (sku_list.length > 0) {
                this.add_bundle(sku_list);
            }

            resolve();
        });
    },

    fill_bonuses: function() {
        $(".cart__usebonus").remove();

        const isCredit = $(".payment__method-active").hasClass('credit');
        const value = isCredit ? this.available_bonuses.amount_credit : this.available_bonuses.amount;

        console.log('fill_bonuses', value, this.allow_bonuses);

        if (value > 0 && this.allow_bonuses) {
            const active = this.bonuses_entered >= 0 || this.bonus_opened;

            $(`<div class="cart__usebonus ${G.manager_logged ? `mb24` : `mb4`}">
                <div class="services-list" ${G.manager_logged ? `style="padding-top: 0px !important;"` : ``}>
                    <div class="cart__usebonusstr">${value} грн</div>
                    <input type="hidden" name="use_bonus" value="${this.use_bonuses}" />
                    <a href="#" class="services-item-checkbox services-item-checkbox-bonus js-cart__usebonus ${active ? `active` : ``}">Оплатити бонусами</a>
                </div>
                
                <div class="cart__usebonusamount ${active ? `` : `hidden`} mt4">
                    <div class="cart__usebonusloader"></div>
                    <input type="number" class="disablearrows unstyled js-input__forcemax" value="${this.bonuses_entered >= 0 ? (this.bonuses_entered > value ? value : this.bonuses_entered) : 0}" placeholder="Використати 0" data-min="0" data-max="${value}"/>
                    <span>/ ${value} грн</span>
                </div>
            </div>`).insertBefore($(".do-not-call-container"));

            // if (this.bonuses_entered >= 0 || this.use_bonuses > 0) {
            //     let b = this.use_bonuses > 0 ? this.use_bonuses : this.bonuses_entered;
                // $(".js-cart__usebonus").trigger('click');
                // $(".cart__usebonus [type=number]").val(b).trigger('keyup');
            // }
        }
    },

    set_bonus_loading: function(set = true)
    {
        if (set) {
            $(".cart__usebonus").addClass('cart__usebonus-loading');
        } else {
            $(".cart__usebonus").removeClass('cart__usebonus-loading');
        }
    },

    update_bonuses: function(force = false)
    {
        setTimeout(() => {
            if (G.channel!=3 && (!this.bonus_request_send || force)) {
                if (this.available_bonuses.ts==0 || force) {
                    if ($(".cart__usebonus").length > 0) {
                        this.bonuses_entered = parseInt($(".cart__usebonus .js-input__forcemax").val());
                    }

                    this.set_bonus_loading();
                    this.bonus_request_send = true;

                    this.postData(
                        {
                            action: 'basket',
                            to: 'available_bonuses',
                        }
                    ).then((data) => {
                        this.bonus_request_send = false;
                        this.available_bonuses = data;
                        this.fill_bonuses();
                    }).finally(() => {
                        this.set_bonus_loading(false);
                    });
                } else {
                    this.fill_bonuses();
                }
            }
        }, 0);
    },

    skus: function() {
        let result = [];

        if ($(".cart__items .cart__item").length > 0)
            $.each($(".cart__items .cart__item"), (i, item) => {
                 result.push($(item).data('sku'));
            });

        return result;
    },

    upsale_mystore_value: function() {
        let mystore = G.manager_logged ? G.mystore : 0;

        if ($(".js-cart__upsalemystore").length > 0)
            mystore = $(".js-cart__upsalemystore").hasClass('checked') ? 1 : 0;

        return mystore;
    },

    save_comment: function() {
        if ($(".cart [name=comment]").length > 0 && $.trim($(".cart [name=comment]").val())!='') {
            this.postData(
                {
                    action: 'basket',
                    to: 'savecomment',
                    text: $(".cart [name=comment]").val()
                }
            );
        }
    },

    load_upsale_window: function(sku) {

        return this.postData(
            {
                action: 'basket',
                to: 'upsalewindow',
                exclude: this.skus().join(','),
                sku: sku,
                mystore: this.upsale_mystore_value()
            }
        ).then((data) => {
            // build window
            if ($(".cart__upsale").length==0) {
                let slr_html = G.manager_logged ? `<div class="cart__upsalemystore user__menuli icon-switchstore"><a href="#" class="js-cart__upsalemystore ${G.mystore?'checked':''}" data-sku="${sku}">Мій магазин</a></div>` : '';
                $(".cart").append(`<div class="cart__upsale">
                    <div class="cart__upsaleheader">
                        <a href="javascript: void(null);" class="cart__collapse"></a>
                        <div class="cart__titled">Аксесуари</div>
                        ${slr_html}
                    </div>
                    <div class="cart__upsalecontent"><div class="cart__upsalecontentinner"></div></div>
                </div>`);
            }

            $(".cart").addClass('cart-openedupsale');

            return data;
        }).then((data) => {
            $(".cart__upsalecontentinner").html(data.html);
        });
    },

    load_upsale_tab: function(sku, btn) {
        return this.postData(
            {
                action: 'basket',
                to: 'upsalewindowtab',
                exclude: this.skus().join(','),
                sku: sku,
                context_id: btn.data('category'),
                mystore: this.upsale_mystore_value()
            }
        ).then((data) => {
            // build window
            $(".js-cart__accschangetab").removeClass('active');
            btn.addClass('active');
            $(".cart__accstabscontent .cart__accstab").html(data.html);
        });
    },

    removePromocode: function() {
        this.set_force_update(1);

        return this.postData(
            {
                action: 'basket',
                to: 'removepromocode',
            }
        ).then((data) => {
            this.onorderpage = 1;
            this.updatePromise();
        });
    },

    block_checkout: function(block = false) {
        // $(".cart .checkout .cart__checkoutblock").remove();
        console.trace('block_checkout', block);
        if (block) {
            $(".cart .checkout").append('<div class="cart__checkoutblock"></div>');
        } else {
            if ($(".cart .checkout .cart__checkoutblock").length > 0) {
                $(".cart .checkout .cart__checkoutblock").fadeOut(200, function () {
                    $(this).remove();
                });
            }
        }
    },

    check_postomat_overprice: function() {
        return (this.sum.uah > 6000) ? false : true;
    },

    show_error_postomat_overprice: function(show) {
        if (show) {
            $(".delivery__choose .alert").html(__('Максимальна сума кошика для відправки у поштомат 6000грн.')).removeClass('hidden');
        } else {
            $(".delivery__choose .alert").addClass('hidden');
        }
    },

    save_courier_delivery_data: function(clear) {
        // save delivery np address
        let data = {};
        if (clear) {
            data.street = '';
            data.street_name = '';
            $(".cart .selected-method:not(.hidden) .for-address-select select").val('').trigger('change');
            data.house = '';
            data.app = '';
            data.note = '';
            data.floor = '';
        } else {
            data.street = $(".cart .selected-method:not(.hidden) .for-address-select select option:selected").val();
            data.street_name = $(".cart .selected-method:not(.hidden) .for-address-select select option:selected").text();
            data.house = $(".cart .selected-method:not(.hidden) [name='naddress[house]']").val();
            data.app = $(".cart .selected-method:not(.hidden) [name='naddress[app]']").val();
            data.note = $(".cart .selected-method:not(.hidden) [name='naddress[note]']").val();
            data.floor = $(".cart .selected-method:not(.hidden) [name='naddress[floor]']").val();
        }
        return data;
    },

    open_in_credit: function(callback) {
        $.post(
            '/aj',
            {
                action: 'basket',
                to: 'buyincredit',
                mobile: (U.isMobile()?1:0),
                locale: G.locale_id,
                page: document.location.pathname,
            },
            (data) => {

                this.open()
                    .then(() => {
                        this.updatePromise();
                    })
                    .then(() => {
                        if (data.count_items) {
                            this.window('process-checkout buy-in-credit', data.window);
                            this.set_card_count(data.count_items, data);

                            if (typeof callback === "function")
                                callback();
                        }
                    });
                return;
            },
            'json'
        );
    },

    hook_change_delivery: function() {
        let value = $(".delivery__method.active").length > 0 ? $(".delivery__method.active input").val() : ''

        if (value) {
            let city_id = $(".cart [name=delivery_city]").val();
            let container = $('.selected-method[data-name=' + value + ']');

            if (value == 'novaposhta') {
                $(".selected-method[data-name=novaposhta] .fh66").addClass('cart__warehouse-loading');
                $.post('/aj',
                    {
                        action: 'novaposhta',
                        locale: G.locale_id,
                        to: 'warehouses',
                        showpostomates: $('.selected-method[data-name=novaposhta] .for-warehouse').data('showpostomates'),
                        showdropoff: $('.selected-method[data-name=novaposhta] .for-warehouse').data('showdropoff'),
                        city_id: city_id
                    },
                    (data) => {
                        $(".selected-method[data-name=novaposhta] .fh66").removeClass('cart__warehouse-loading');
                        $(".selected-method[data-name=novaposhta] .for-warehouse *:not(label)").remove();
                        if (data.length) {
                            let selected = $('.selected-method[data-name=novaposhta] .for-warehouse').data('selected');

                            let select = '<option value="">' + __('Оберіть відділення зі списку') + '</option>';
                            $.each(data, function (index, item) {
                                select = select + '<option value="' + item.id + '" ' + (item.id == selected ? 'selected' : '') + '>' + item.title + '</option>';
                            });

                            $('.selected-method[data-name=novaposhta] .for-warehouse').append('<select name="nwarehouse" data-placeholder="' + __('Оберіть відділення зі списку') + '" placeholder="' + __('Оберіть відділення зі списку') + '">' + select + '</select>');
                            $('.selected-method[data-name=novaposhta] .for-warehouse select').select2({}).focus().trigger('change');
                            $('.selected-method[data-name=novaposhta] .for-warehouse').removeClass('hidden');
                        }
                    },
                    'json'
                );
            }

            if (value == 'novaposhta_postomat') {
                $.post('/aj',
                    {
                        action: 'novaposhta',
                        locale: G.locale_id,
                        to: 'postomates',
                        city_id: city_id
                    },
                    (data) => {
                        $(".selected-method[data-name=novaposhta_postomat] .for-warehouse *:not(label)").remove();
                        if (data.length) {
                            let selected = $('.selected-method[data-name=novaposhta_postomat] .for-warehouse').data('selected');

                            let select = '<option value="">' + __('Оберіть поштомат зі списку') + '</option>';
                            $.each(data, function (index, item) {
                                select = select + '<option value="' + item.id + '" ' + (item.id == selected ? 'selected' : '') + '>' + item.title + '</option>';
                            });

                            $('.selected-method[data-name=novaposhta_postomat] .for-warehouse').append('<select name="npostomat" data-placeholder="' + __('Оберіть поштомат зі списку') + '" placeholder="' + __('Оберіть поштомат зі списку') + '">' + select + '</select>');
                            $('.selected-method[data-name=novaposhta_postomat] .for-warehouse select').select2({}).focus().trigger('change');
                            $('.selected-method[data-name=novaposhta_postomat] .for-warehouse').removeClass('hidden');
                        }
                    },
                    'json'
                );
            }

            if (value == 'shop_delivery') {
                $.post('/aj',
                    {
                        action: 'basket',
                        locale: G.locale_id,
                        to: 'shops',
                        city_id: city_id
                    },
                    (data) => {
                        $(".selected-method[data-name=shop_delivery] .for-warehouse *:not(label)").remove();
                        if (data.length) {
                            let selected = $('.selected-method[data-name=shop_delivery] .for-warehouse').data('selected');

                            let select = '<option value="">' + __('Оберіть магазин зі списку') + '</option>';
                            $.each(data, function (index, item) {
                                select = select + '<option value="' + item.id + '" ' + (item.id == selected ? 'selected' : '') + '>' + item.title + '</option>';
                            });

                            $('.selected-method[data-name=shop_delivery] .for-warehouse').append('<select name="shop" data-placeholder="' + __('Оберіть магазин зі списку') + '" placeholder="' + __('Оберіть магазин зі списку') + '">' + select + '</select>');
                            $('.selected-method[data-name=shop_delivery] .for-warehouse select').select2({}).focus().trigger('change');
                            $('.selected-method[data-name=shop_delivery] .for-warehouse').removeClass('hidden');
                        }
                    },
                    'json'
                );
            }

            if (value == 'novaposhtac') {
                $(".selected-method[data-name=novaposhtac] .fh66").addClass('cart__warehouse-loading');
                $.post('/aj',
                    {
                        action: 'novaposhta',
                        locale: G.locale_id,
                        to: 'streets',
                        ref: city_id
                    },
                    (data) => {
                        $(".selected-method[data-name=novaposhtac] .for-address-select *:not(label)").remove();
                        $(".selected-method[data-name=novaposhtac] .fh66").removeClass('cart__warehouse-loading');
                        if (data.length) {
                            let selected = $('.selected-method[data-name=novaposhtac] .for-address-select').data('val');
                            let select = '<option value="">' + __('Оберіть вулицю') + '</option>';

                            $.each(data, function (index, item) {
                                if (item.id == selected ? 'selected' : '')
                                    select = select + '<option value="' + item.id + '" selected>' + item.text + '</option>';
                            });

                            $('.selected-method[data-name=novaposhtac] .for-address-select').append('<select name="naddress[street]" data-placeholder="' + __('Оберіть вулицю') + '" placeholder="' + __('Оберіть вулицю') + '">' + select + '</select>');
                            $('.selected-method[data-name=novaposhtac] .for-address-select select').select2({
                                placeholder: __("Введіть назву вулиці..."),
                                minimumInputLength: 3,
                                ajax: {
                                    url: '/aj',
                                    type: "POST",
                                    dataType: "json",
                                    data: function (term) {
                                        return {
                                            term: term['term'],
                                            action: 'novaposhta',
                                            to: 'streets',
                                            ref: city_id,
                                            locale: G.locale_id,
                                        };
                                    },
                                    processResults: function (data, page) {
                                        return {
                                            results: data
                                        };
                                    }
                                }
                            }).focus().trigger('change');

                            $('.selected-method[data-name=novaposhtac] .for-address-select').removeClass('hidden');
                        }
                    },
                    'json'
                );
            }

            if (value == 'ktcpost') {
                $(".selected-method[data-name=ktcpost] .fh66").addClass('cart__warehouse-loading');
                $.post('/aj',
                    {
                        action: 'novaposhta',
                        locale: G.locale_id,
                        to: 'streets',
                        ref: city_id
                    },
                    (data) => {

                        if (data.length) {
                            let select = '<option value="">' + __('Оберіть вулицю') + '</option>';
                            let selected = $('.selected-method[data-name=ktcpost] .for-address-select').data('val');
                            $(".selected-method[data-name=ktcpost] .fh66").removeClass('cart__warehouse-loading');

                            if ($('.selected-method[data-name=ktcpost] .for-address-select select').length == 0) {
                                $.each(data, function (index, item) {
                                    if (item.id == selected ? 'selected' : '')
                                        select = select + '<option value="' + item.id + '" ' + (item.id == selected ? 'selected' : '') + '>' + item.text + '</option>';
                                });

                                $('.selected-method[data-name=ktcpost] .for-address-select').append('<select name="naddress[street]" data-placeholder="' + __('Оберіть вулицю') + '" placeholder="' + __('Оберіть вулицю') + '">' + select + '</select>');
                                $('.selected-method[data-name=ktcpost] .for-address-select select').select2({
                                    placeholder: __("Введіть назву вулиці..."),
                                    minimumInputLength: 3,
                                    width: "15em",
                                    ajax: {
                                        url: '/aj',
                                        type: "POST",
                                        dataType: "json",
                                        data: function (term) {
                                            return {
                                                term: term['term'],
                                                action: 'novaposhta',
                                                to: 'streets',
                                                ref: city_id,
                                                locale: G.locale_id,
                                            };
                                        },
                                        processResults: function (data, page) {
                                            return {
                                                results: data
                                            };
                                        }
                                    }
                                }).focus().trigger('change');

                                $('.selected-method[data-name=ktcpost] .for-address-select').removeClass('hidden');
                            }
                        }
                    },
                    'json'
                );
            }

            if (value == 'uklon') {
                $(".selected-method[data-name=uklon] .fh66").addClass('cart__warehouse-loading');
                $.post('/aj',
                    {
                        action: 'novaposhta',
                        locale: G.locale_id,
                        to: 'streets',
                        ref: city_id
                    },
                    (data) => {

                        if (data.length) {
                            let select = '<option value="">' + __('Оберіть вулицю') + '</option>';
                            let selected = $('.selected-method[data-name=uklon] .for-address-select').data('val');
                            $(".selected-method[data-name=uklon] .fh66").removeClass('cart__warehouse-loading');

                            if ($('.selected-method[data-name=uklon] .for-address-select select').length == 0) {
                                $.each(data, function (index, item) {
                                    if (item.id == selected ? 'selected' : '')
                                        select = select + '<option value="' + item.id + '" ' + (item.id == selected ? 'selected' : '') + '>' + item.text + '</option>';
                                });

                                $('.selected-method[data-name=uklon] .for-address-select').append('<select name="naddress[street]" data-placeholder="' + __('Оберіть вулицю') + '" placeholder="' + __('Оберіть вулицю') + '">' + select + '</select>');
                                $('.selected-method[data-name=uklon] .for-address-select select').select2({
                                    placeholder: __("Введіть назву вулиці..."),
                                    minimumInputLength: 3,
                                    width: "15em",
                                    ajax: {
                                        url: '/aj',
                                        type: "POST",
                                        dataType: "json",
                                        data: function (term) {
                                            return {
                                                term: term['term'],
                                                action: 'novaposhta',
                                                to: 'streets',
                                                ref: city_id,
                                                locale: G.locale_id,
                                            };
                                        },
                                        processResults: function (data, page) {
                                            return {
                                                results: data
                                            };
                                        }
                                    }
                                }).focus().trigger('change');

                                $('.selected-method[data-name=ktcpost] .for-address-select').removeClass('hidden');
                            }
                        }
                    },
                    'json'
                );
            }

            if (value == 'ukrpost') {
                let selected = $('.selected-method[data-name=ukrpost] .for-warehouse').data('selected');
                $(".selected-method[data-name=ukrpost] .for-warehouse *:not(label)").remove();
                $(".selected-method[data-name=ukrpost] .for-warehouse").addClass('cart__warehouse-loading');

                $.post(
                    '/aj',
                    {
                        action: 'ukrpost',
                        to: 'warehouses',
                        locale: G.locale_id,
                        // region_id: region_id,
                        city_id: city_id
                    },
                    (data) => {
                        if (data.length > 0) {

                            let select = '';
                            let was_selected = false;
                            $.each(data, function (index, item) {
                                select = select + '<option data-id="' + item.id + '" value="' + item.title + '" ' + (!was_selected && item.title.substr(0, 7) == selected.substr(0, 7) ? 'selected' : '') + '>' + item.title + '</option>';
                                if (item.title.substr(0, 7) == selected.substr(0, 7)) {
                                    was_selected = true;
                                }
                            });

                            $(".selected-method[data-name=ukrpost] .for-warehouse").append('<select class="form-select" name="uwarehouse"><option value="">' + __('Оберіть відділення зі списку') + '</option>' + select + '</select>');
                            $(".selected-method[data-name=ukrpost] .for-warehouse select").select2({}).focus().trigger('change');
                            $(".selected-method[data-name=ukrpost] .for-warehouse").removeClass('cart__warehouse-loading');
                        } else {
                            $(".selected-method[data-name=ukrpost] .for-warehouse").removeClass('cart__warehouse-loading');
                            $(".selected-method[data-name=ukrpost] .for-warehouse").html('<div class="alert alert-danger">Немає доступних відділень</div>');
                        }
                    }, 'json');
            }

            if (value == 'self') {
                container.find('label.radiobox').addClass('hidden');
                let delivery_value = '';

                container.find('label.radiobox[data-city=' + city_id + ']').removeClass('hidden');

                if (container.find('label.radiobox[data-city=' + city_id + ']').length == 1) {
                    delivery_value = container.find('label.radiobox[data-city=' + city_id + '] input');
                    container.find('label.radiobox[data-city=' + city_id + ']').trigger('click');
                }

                container.find('input').prop('checked', false);
                $(".selected-method[data-name=self] .for-store").removeClass('hidden');
            }
        }

        ANOTHERRECIPIENT.trigger_show();
        if (G.manager_logged) {
            $(".payment__methodchange").trigger('click');
            SLR.SLR.possible_submit();
        } else {
            this.possible_submit_delivery();
        }
    },

    format_price: function(price) {
        return new Intl.NumberFormat('ru-RU').format(price);
    },

    google_ask: function(data) {
        if (G.channel != 7)
            if (typeof data.order === "object" && !(typeof data.order.email === "undefined") && (!(typeof data.order.google_ask === "undefined") && data.order.google_ask > 0) && !(data.order.email=='') && !(data.order.email=='undefined')) {

                setTimeout(function(){
                    $.getScript('https://apis.google.com/js/platform.js', function () {
                        window.___gcfg = {
                            lang: G.locale_id==1 ? 'ru' : 'uk'
                        };

                        window.gapi.load('surveyoptin', function () {
                            window.gapi.surveyoptin.render(
                                {
                                    "merchant_id": 117195258,
                                    "order_id": data.order.id,
                                    "email": data.order.email,
                                    "delivery_country": "UA",
                                    "estimated_delivery_date": data.order.delivery_date,
                                    "opt_in_style": "CENTER_DIALOG"
                                });
                        });
                    });
                }, data.order.google_ask);
            }
    },

    delivery_error_text: function() {
        return this._delivery_error_text;
    },

    possible_submit_delivery: function() {
        let result = false;

        this._delivery_error_text = __('Оберіть метод доставки');

        if ($(".delivery__method.active").length > 0) {
            let method = $(".delivery__method.active");

            switch(method.find('input[name=delivery]').val()) {
                case 'self':
                    if ($(".selected-method[data-name=self] label.active").length > 0)
                        result = true;
                    break;
                case 'ukrpost':
                    if ($(".selected-method[data-name=ukrpost] select").val()) {
                        result = true;
                    } else {
                        this._delivery_error_text = 'Оберіть відділення';
                    }
                    break;
                case 'shop_delivery':
                    if ($(".selected-method[data-name=shop_delivery] select").val()) {
                        result = true;
                    }
                    break;
                case 'novaposhta':
                    if ($(".selected-method[data-name=novaposhta] select[name=nwarehouse]").val()) {
                        result = true;
                    } else {
                        this._delivery_error_text = 'Оберіть відділення';
                    }
                    break;
                case 'novaposhtac':
                    if ($(".selected-method[data-name=novaposhtac] select").val() && $(".selected-method[data-name=novaposhtac] .for-house").val()) {
                        result = true;
                    } else {
                        this._delivery_error_text = 'Заповніть адресу отримувача';
                    }
                    break;
                case 'novaposhta_postomat':
                    if ($(".selected-method[data-name=novaposhta_postomat] select").val())
                        result = true;
                    break;
                case 'ktcpost':
                    if ($(".selected-method[data-name=ktcpost] select").val() && $(".selected-method[data-name=ktcpost] .for-house").val())
                        result = true;
                    break;
                case 'uklon':
                    if ($(".selected-method[data-name=uklon] select").val() && $(".selected-method[data-name=uklon] .for-house").val())
                        result = true;
                    break;
                default:
                    break;
            }
        }

        // last name
        let selected_container = $(".selected-method:not(.hidden)");

        if (selected_container.find('[name=last_name]').length > 0 && selected_container.find('[name=last_name]').hasClass('required')) {
            if (selected_container.find('[name=last_name]').val()=='') {
                result = false;
                this._delivery_error_text = 'Потрібно заповнити значення По батькові';
            }
        }

        // another recipient
        if (ANOTHERRECIPIENT.showed() && !ANOTHERRECIPIENT.valid()) {
            result = false;
            console.log('!valid', ANOTHERRECIPIENT.error_text());
            this._delivery_error_text = ANOTHERRECIPIENT.error_text();
        }

        // fill name
        if (selected_container.find('[name=first_name]').length > 0) {
            let first_name = selected_container.find('[name=first_name]');
            let middle_name = selected_container.find('[name=middle_name]');

            if (
                $.trim(first_name.val())!='' &&
                $.trim(middle_name.val())!='' &&
                (
                    selected_container.find('[name=last_name]').length==0 ||
                    (
                        !selected_container.find('[name=last_name]').hasClass('required') ||
                        $.trim(selected_container.find('[name=last_name]').val())!=''
                    )
                )
            ) {} else {
                this._delivery_error_text = 'Заповніть імʼя користувача';
                result = false;
            }
        }

        if (result)
            $(".submit-cart-delivery").addClass('active');
        else
            $(".submit-cart-delivery").removeClass('active');

        return result;
    },

    save_user_phone: function() {
        try {
            $.post(
                '/aj',
                {
                    action: 'basket',
                    to: 'savephone',
                    locale: G.locale_id,
                    phone: $(".cart .scroll[data-step=1] [name=login]").val(),
                },
                (data) => {
                    return;
                },
                'json'
            );
        } catch(e){}
    },

    possible_submit_register: function() {
        var result = false;

        if (USER.is_logged()) {
            if (
                ($(".tform-cartprofile [name=login]").length && $(".tform-cartprofile [name=login]").val().replace(/[^\d]/g, '').length==10) ||
                ($(".tform-phonewizard [name=login]").length && $(".tform-phonewizard [name=login]").val().replace(/[^\d]/g, '').length==10)
            ) {
                result = true;
            }
        } else {
            if ($(".tform-auth [name=unregistered]").prop('checked')) {
                result = true;
            }
        }

        return result;
    },

    possible_submit_pay: function(show_errors = false) {
        let result = false;

        if (!($(".cart__paymentouter [name=payment]").val()=='' || typeof $(".cart__paymentouter [name=payment]").val()==="undefined"))
            result = true;

        if (this.payment_method=='googlepay')
            result = true;

        if (this.total_overhead)
            result = false;

        if (this.payment_method=='cashless') {
            if (G.b2bmode) {
                if (!$(".cart [name=contractor]").val()) {
                    result = false;
                }
            } else {
                /* перероблюємо на перевірку данних при кліку на "продовжити" (відправити замовлення) */

                if (show_errors) {
                    if ($(".cart__searchcompanyaddform").hasClass('hidden')) {
                        if (!($(".cart__searchcompanyresults-active [name=edrpou]:checked").val() || $(".cart__searchcompanypredefined [name=edrpou]:checked").val()))
                            result = false;
                    } else {
                        if (!(
                            ($("[name=searchcompany_edrpou]").val().length >= 8) &&
                            $.trim($("[name=searchcompany_address]").val()).length >= 5
                        ))
                            result = false;
                    }
                }
            }
        }

        if (result)
            $(".submit-cart-pay").addClass('active');
        else {
            $(".submit-cart-pay").removeClass('active');

            if (show_errors) {
                // cashless
                if (this.payment_method=='cashless') {
                    if (!G.b2bmode) {
                        if ($(".cart__searchcompanyaddform").hasClass('hidden')) {
                        } else {
                            if (!($("[name=searchcompany_edrpou]").val().length >= 8)) {
                                $("[name=searchcompany_edrpou]").parent().find('label').removeClass('hidden');
                            }

                            if (!($.trim($("[name=searchcompany_address]").val()).length >= 5)) {
                                $("[name=searchcompany_address]").parent().find('label').removeClass('hidden');
                            }
                        }
                    }
                }

            }
        }

        return result;
    },

    removePaymentStep: function() {

    },

    // check
    go_step: function(step) {
        if (G.manager_logged) {
            return this.open_checkout();
        } else {
            return this.load_step(step);
        }
    },

    show_do_not_call: function(show, checked = false) {
        if (show) {
            $(".do-not-call-container").removeClass('hidden');

            if (!$(".cart .do-not-call-container a").hasClass('user-clicked')) {
                $(".cart [name=do_not_call]").val(checked ? 1 : 0);

                if (checked) {
                    $(".cart .do-not-call-container a").addClass('active');
                } else {
                    $(".cart .do-not-call-container a").removeClass('active');
                }
            }
        }
        else {
            $(".do-not-call-container").addClass('hidden');
            $(".cart .do-not-call-container a").removeClass('active');
            $(".cart [name=do_not_call]").val(0);
        }
    },

    fix_content_height: function() {
        let height = $(".cart__bottom").is(':visible') ? $(".cart__bottom").outerHeight() : 0;
        $(".cart__content").css('height', 'calc(100% - ' + height + 'px)');
    },

    // check
    sumParam: function() {
        return '&sum[uah]=' + this.sum.uah+'&sum[usd]='+this.sum.usd;
    },

    // check
    compareSum: function(sum) {
        let res = false;

        let new_uah = (sum.uah === undefined) ? 0 : sum.uah;
        let new_usd = (sum.usd === undefined) ? 0 : sum.usd;

        if (this.uah==new_uah && this.usd==new_usd)
            res = true;

        return res;
    },

    // check
    sumStr: function() {
        let str = [];

        if (this.sum.deliveryTotal > 0)
            str.push(this.sum.deliveryTotal + '&nbsp;грн');

        if (this.sum.usd > 0)
            str.push(this.sum.usd + '&nbsp;у.о.');

        str = str.length > 0 ? str.join(', ') : '0&nbsp;грн';
        return str;
    },

    // check
    setSum: function(arr) {
        this.sum = {
            uah: 0,
            usd: 0,
            paymentTotal: 0,
            deliveryTotal: 0
        };

        if (!(arr.usd === undefined))
            this.sum.usd = arr.usd;

        if (!(arr.uah === undefined))
            this.sum.uah = arr.uah;

        if (!(arr.paymentTotal === undefined))
            this.sum.paymentTotal = arr.paymentTotal;

        if (!(arr.deliveryTotal === undefined))
            this.sum.deliveryTotal = arr.deliveryTotal;
    },

    trigger_one_delivery_method: function() {
        if ($(".delivery__methods >.delivery__method:not(.hidden)").length==1) {
            $(".delivery__methods >.delivery__method:not(.hidden)").trigger('click');
        }
    },

    update_delivery_methods: function() {
        $(".delivery__methods").addClass('delivery__methods-loading');

        return this.postData(
            {
                action: 'basket',
                to: 'deliverymethods',
                city_id: $(".cart [name=delivery_city]").val()
            }
        ).then((data) => {
            $(".delivery__choose").removeClass('hidden');
            $(".delivery__methods").removeClass('hidden').find('>.delivery__method').addClass('hidden hidden-trigger');

            if (data.methods && data.methods.length > 0) {
                $.each(data.methods, function(i, method) {
                    $(".delivery__method." + method.name + " .delivery__methoddate").addClass('hidden');
                    $(".delivery__method." + method.name).removeClass('hidden hidden-trigger active').addClass(method.class);

                    if (method.dates)
                        $(".delivery__method." + method.name + " .delivery__methoddate").removeClass('hidden').html(method.dates);
                });
            }

            this.trigger_one_delivery_method();

            if (data.error) {
                $(".delivery__choose >.alert").html(data.message).removeClass('hidden');
            } else {
                $(".delivery__choose >.alert").addClass('hidden');
            }
        }).finally(() => {
            $(".delivery__methods").removeClass('delivery__methods-loading');
        });
    },

    save_all_delivery: function(reset = false) {
        const fields = {
            delivery: '',
            delivery_title: '',
            delivery_1: $(".cart [name=delivery_city]").val(),
            delivery_2: '',
            delivery_3: '',
            naddress: {
                street: '',
                street_name: '',
                house: '',
                app: '',
                note: '',
                floor: ''
            },
            anotherrecipient_phone: '',
            anotherrecipient_name: ''
        };

        if (!reset) {
            fields.delivery = $(".delivery__methods .delivery__method.active input[name=delivery]").val();
            fields.delivery_title = $(".delivery__methods .delivery__method.active .delivery__methodtitle").text();
            fields.anotherrecipient_phone = $(".cart__anotherrecipient").hasClass('hidden') ? '' : $(".cart__anotherrecipient [name=anotherrecipient_phone]").val();
            fields.anotherrecipient_name = ANOTHERRECIPIENT.get_name();
            fields.delivery_name = $(".delivery__methods .delivery__method.active input[name=delivery]").val();

            // delivery params
            switch(fields.delivery) {
                case 'self':
                    fields.delivery_2 = $(".selected-method[data-name=self] .for-store label.active input").val();
                    break;

                case 'novaposhta':
                    fields.delivery_2 = $(".selected-method[data-name=novaposhta] .for-warehouse select").val();
                    break;

                case 'novaposhta_postomat':
                    fields.delivery_2 = $(".selected-method[data-name=novaposhta_postomat] .for-warehouse select").val();
                    break;

                case 'ukrpost':
                    fields.delivery_3 = $(".selected-method[data-name=ukrpost] .for-warehouse select").val();
                    break;

                case 'novaposhtac':
                case 'ktcpost':
                case 'uklon':
                    fields.naddress = this.save_courier_delivery_data();
                    break;

                default:
                    break;
            }
        }

        this.delivery = fields;

        return this.postData(
            {
                action: 'basket',
                to: 'savedelivery',
                locale: G.locale_id,
                fields: JSON.stringify(fields)
            }
        );
    },

    save_fields: function(field, value, fields = []) {
        return this.postData(
            {
                action: 'basket',
                to: 'savefields',
                locale: G.locale_id,
                field: field,
                value: value,
                fields: JSON.stringify(fields)
            }
        );
    },

    add_with_services: function(sku, after, count) {
        return $.post(
            '/aj',
            {
                action: 'basket',
                to: 'add',
                update: 1,
                locale: G.locale_id,
                sku: sku,
                after: after,
                count: count
            },
            (data) => {
                return this.open().then(() => {
                    this.updatePromise();
                });
            },
            'json'
        );
    },

    add_service: function(sku, was, after, count) {
        return $.post(
            '/aj',
            {
                action: 'basket',
                to: 'addservice',
                update: 1,
                locale: G.locale_id,
                sku: sku,
                was: was,
                after: after,
                count: count
            },
            (data) => {
                this.updatePromise();
            },
            'json'
        );
    },

    getGoogleAnalyticsClientId: function() {
        let clientId = null;

        if (typeof ga === 'function' && typeof ga.getAll==='function') {
            // Get the tracker object
            let trackers = ga.getAll();

            // Retrieve the clientId from the first tracker
            if (trackers.length > 0) {
                clientId = trackers[0].get('clientId');
            }
        }

        return clientId;
    },

    // check
    open: function(callback, payment_method = ''){
        return new Promise((resolve, reject) => {

            Cookies.remove('merge_after_login');

            this.payment_method = payment_method;

            if (!$(".cart").length)
                $("body").append('<div class="cart cart-empty cart-loader">\n' +
                    '    <div class="cart__content">\n' +
                    '        <div class="cart__title">' + __('Кошик') + '</div>\n' +
                    '        <a href="javascript: void(null);" class="cart__close"></a>' +
                    '        <a href="javascript: void(null);" class="cart__collapse"></a>' +
                    '        <div class="cart__items"></div>' +
                    '    </div>\n' +
                    '    <div class="cart__bottom">\n' +
                    '        <div class="cart__bottomcont">\n' +
                    '            <div class="cart__personalpromo js-cart__personalpromo hidden"></div>\n' +
                    '        <div class="promocode promocode-cart hidden clearfix">\n' +

                    '<div class="alert alert-danger alert-promocode hidden">' + __('Промо-код не знайдений') + '</div>' +
                    '<input type="text" name="promocode" value="" size="60" placeholder="' + __('Промокод') + '" maxlength="60" class="promocode__input promocode__input-cartbottom" autocomplete="off" aria-autocomplete="none">' +
                    '<button type="button" value="" class="anchor promocode__submit promocode__submit-cartbottom">' + __('Додати') + '</button>'+
                    '<button type="button" value="" class="anchor promocode__removecartbottom hidden">' + __('Видалити') + '</button>'+

                    '        </div>\n' +
                    '        <span class="cart__delivery">\n' +
                    '            <span class="cart__deliverystr"></span>\n' +
                    '            <a href="#" class="cart__promocodebtn">' + __('Додати промокод') + '</a>\n' +
                    '        </span>\n' +
                    '        <span class="cart__amount">\n' +
                    '            <span class="js-cart__topaystring">' + __('До оплати') + ':</span>\n' +
                    '            <span class="cart__total"><small class="js-cart__num"></small><span class="js-cart__total"></span></span>\n' +
                    '        </span>\n' +
                    '        <button class="go-checkout" type="button">' + __('Оформити замовлення') + '</button>\n' +
                    '        <div class="mobileVisible extra-buttons"></div>' +
                    '        </div>' +
                    '    </div>\n' +
                    '</div>');

            DRAWER.destroy();
            $("body, html").addClass('disablescroll');
            $(".cart").addClass('cart-show');
            $(".menubg").addClass('show');

            this.fix_content_height();

            if (G.manager_logged) {
                $(".cart").addClass('ok');
                $(".cart__title").html('<a href="#" class="change-cart">' + __('Кошик') + '</a>');

                if (!$(".sku-search").length) {
                    $(".cart__title").append(`
                        <div class="sku-search">
                            <a href="javascript: void(null);" class="qr-sku-close mobileVisible"></a>
                            <a href="javascript: void(null);" class="qr-sku-search mobileVisible"></a>
                            <input type="text" placeholder="Пошук по товарах або коду"/>
                        </div>
                        <div class="search-goods hidden"></div>`
                    ).addClass('cart__title-slr');

                    if (!U.isMobile())
                        $(".sku-search input").get(0).focus();
                }
            }

            if (G.b2bmode) {
                $(".cart__title").html('<a href="#" class="change-cart">' + __('Кошик') + '</a>');
                B2B.B2B.cart_open_hook();
            }

            U.mask_inputs();
            resolve(true);
        });
    },

    // check
    toggle: function(force_open = false){
        if (this.opened() && !force_open)
            this.close();
        else {
            this.open().then(() => {
                this.set_force_update(1);
                this.updatePromise().then(() => {
                    this.gtm_event_view_cart();
                });
            });
        }
    },

    // check
    opened: function(){
        return ($('.cart-show').length > 0) ? true : false;
    },

    // check
    close: function(){
        if (Cookies.get('city_id')) {
            let city = Cookies.get('city_id').split(':')[0];

            if (city!=G.city_id) {
                document.location.reload();
                return;
            }
        }

        $(".cart").remove();
        $("body, html").removeClass('disablescroll');
        $(".menubg").removeClass('show');
        clearInterval(this.token_timeout);
        clearTimeout(this.monobank_timeout_handler);
    },

    // check
    fill_guest: function(){

        let go_second = false;

        if (USER.is_logged() || G.manager_logged)
            return;

        if (Cookies.get("guest_name"))
            $(".cart .scroll[data-step=1] [name=name]").val(Cookies.get("guest_name"));


        if (Cookies.get("guest_login")) {
            $(".cart .scroll[data-step=1] [name=login]").val(Cookies.get("guest_login")).trigger('keyup');

            if (Cookies.get("guest_unregistered") && Cookies.get("guest_unregistered")==1)
                $(".cart .scroll[data-step=1] [name=unregistered]").prop('checked', true);

            if (Cookies.get("guest_unregistered") && this.possible_submit_register()) {
                go_second = true;
            }
        }

        if (Cookies.get("guest_email"))
            $(".cart .scroll[data-step=1] [name=email]").val(Cookies.get("guest_email"));

        return go_second;
    },

    set_cart_total: function() {
        $(".js-cart__total").html(G.channel==3 ? this.sumStr() : `${this.paymentTotal()} грн`);
    },

    // check
    set_card_count: function(count, data) {
        if (!(typeof count==="undefined")) {
            $(".header__cart span").remove();
            $(".header__cart").append('<span>' + count + '</span>');
            this.count_items = count;
        }

        if (!(typeof data==="undefined")) {
            this.set_cart_total();
            $(".js-cart__num").html(data.numname);

            if (G.b2bmode)
                $(".cart__deliverystr").html('<a href="#" class="open-goods-paste">Додати товари</a>');
            else
                $(".cart__deliverystr").html(data.deliveryinfo);

            $(".cart__calculate .amount").html(this.sumStr());
            $(".cart__calculate .delivery").html(data.deliveryinfo);
            $(".cart__calculate .total").html(data.numname);
        } else {
            $(".cart__calculate .amount").html(this.sumStr());
            $(".cart__calculate .delivery").html($(".cart__deliverystr").text());
            $(".cart__calculate .total").html($(".cart__total .js-cart__num").text());
        }
    },

    // check
    update_visible_data: function(callback) {
        return new Promise((resolve, reject) => {
            let exist_data = {
                count_items: this.count_items,
                uah: this.sum.uah,
                usd: this.sum.usd
            };

            this.updatePromise().then(() => {
                if (
                    exist_data.count_items==this.count_items &&
                    exist_data.uah==this.sum.uah &&
                    exist_data.usd==this.sum.usd
                ) {
                    resolve(true);
                } else {
                    reject('Кошик оновлено. Перевірте Ваше замовлення.');
                }
            })
        });
    },

    // check
    hideorderform: function() {
        $(".cart").removeClass("process-checkout");
        this.block_promocode(true);
    },

    active_promocode: function() {
        return typeof this.promocode === "object" ? this.promocode.title : '';
    },

    set_card_data: function(data, callback) {

        $(".cart__items").empty();
        $(".cart").removeClass('cart-loader');

        if (data.force_show_thx) {
            this.show_thx(data.lead_id);
            return;
        }

        if (G.channel==2 || G.channel==4)
            $(".cart").addClass('slr');

        this.current_data = [];
        this.user_data = {
            ...this.user_data,
            ...data.user_data
        };

        this.lead_id = data.lead_id;

        // bonuses
        this.available_bonuses = {...data.available_bonuses};
        this.use_bonuses = data.use_bonuses;
        this.allow_bonuses = data.allow_bonuses;

        if (this.available_bonuses.based_on != data.sum.uah && this.step() == 3) {
            console.log('go update_bonuses', this.available_bonuses.amount, data.sum.uah);
            this.update_bonuses(true);
        } else
            this.fill_bonuses();

        // promocode
        this.promocode = data.promocode;
        this.personal_promo = data.personal_promo;

        if (this.promocode || this.personal_promo) {
            $(".cart__promocodebtn").addClass('hidden');
            $(".promocode-cart").removeClass('hidden');
            $(".promocode-cart .promocode__submit").addClass('hidden');
            $(".promocode-cart .promocode__removecartbottom").removeClass('hidden');
            $(".promocode-cart [name=promocode]").val(this.promocode ? this.promocode.title : 'Персональна акція');

            // $(".js-cart__personalpromo").empty().addClass('hidden');
        } else {
            $(".cart__promocodebtn").removeClass('hidden');
            $(".promocode-cart").addClass('hidden');

            // if (this.personal_promo) {
            //     $(".js-cart__personalpromo").html(`<strong>Персональна акція: </strong>${this.personal_promo.title}`).removeClass('hidden');
            // } else {
            //     $(".js-cart__personalpromo").empty().addClass('hidden');
            // }
        }

        this.block_promocode();

        if (data.items.length > 0) {
            if (!($(".cart__items").length))
                $(".cart__content").append('<div class="cart__items"></div>');

            let html = '';
            let was_cloop = false;
            let bundles = [];
            let cart_promo = '';

            $.each(data.items, function(index, item){
                if ((item.sku=="" || item.price=="0.10") && typeof item.fired_promo === "string" && !(item.fired_promo=="")) {

                    if (!(typeof bundles[item.fired_promo]==="object"))
                        bundles[item.fired_promo] = [];

                    if (!(typeof item.promo_type === "undefined") && item.promo_type==9)
                        cart_promo = item.fired_promo;

                    bundles[item.fired_promo].push(item);
                    delete data.items[index];
                }
            });

            if (cart_promo)
                data.items.push({
                    promo_type: 9,
                    fired_promo: cart_promo
                });

            $.each(data.items, (index, item) => {
                if (typeof item === "object") {


                    if (item.promo_type==9) {
                        // акції в кошику
                        if (was_cloop)
                            html += '</div>';

                        let gifts = '';
                        let was_gifts_title = false;

                        if (typeof item.fired_promo === "string" && !(item.fired_promo == "") && typeof bundles[item.fired_promo] === "object") {
                            $.each(bundles[item.fired_promo], function (_index, _item) {
                                _item.bonus = typeof _item.bonus === "number" ? _item.bonus : 0;
                                _item.freeshipping = typeof _item.freeshipping === "number" ? _item.freeshipping : 0;

                                if (_item.sku == "") {
                                    if (_item.bonus) {
                                        // bonus
                                        let amount = parseInt(_item.price.toString().replace(' ', '') * _item.count);
                                        gifts +=
                                            '<div class="cart__giftadd clearfix">\n';

                                        if (!was_gifts_title) {
                                            gifts += '   <span class="cart__subtitle cart__subtitle-icon cart__subtitle-gift">' + __('Подарунок') + '</span>';
                                            was_gifts_title = true;
                                        }

                                        gifts += '<div class="cart__giftfree cart__giftfree-bonus">' +
                                            '           <a href="javascript: void(null);" class="cart__giftfreetitle">+' + amount + ' ' + __('бонусів на рахунок') + '</a>' +
                                            '           <div class="help">' + __('Витрачай їх на наступну покупку') + '</div>' +
                                            '       </div>' +
                                            '</div>';
                                    } else if (_item.freeshipping) {
                                        // freedelivery
                                        gifts +=
                                            '<div class="cart__giftadd clearfix">\n';

                                        if (!was_gifts_title) {
                                            gifts += '   <span class="cart__subtitle cart__subtitle-icon cart__subtitle-gift">' + __('Подарунок') + '</span>';
                                            was_gifts_title = true;
                                        }

                                        gifts +=
                                            '       <div class="cart__giftfree cart__giftfree-delivery">' +
                                            '           <a href="javascript: void(null);" class="cart__giftfreetitle">' + __('Безкоштовна доставка') + '</a>' +
                                            '       </div>' +
                                            '</div>';
                                    } else {
                                        // спецподарок
                                        gifts +=
                                            '<div class="cart__giftadd clearfix">\n';

                                        if (!was_gifts_title) {
                                            gifts += '   <span class="cart__subtitle cart__subtitle-icon cart__subtitle-gift">' + __('Подарунок') + '</span>';
                                            was_gifts_title = true;
                                        }

                                        let price_old = _item.price_old == "" || _item.price_old == "0" ? '' : '<del>' + _item.price_old + '</del>';

                                        gifts +=
                                            '   <div class="cart__giftlist">' +
                                            '       <div class="cart__gift cart__gift-selected">' +
                                            '           <a href="' + (_item.link == '' ? 'javascript: void(null);' : _item.link) + '" class="cart__giftimage"><img src="' + _item.image + '"></a>' +
                                            '           <a href="' + (_item.link == '' ? 'javascript: void(null);' : _item.link) + '" class="cart__gifttitle">' + _item.title + '</a>' +
                                            '           <div class="cart__giftprice">' + price_old + _item.price + '&nbsp;грн' + '</div>' +
                                            '       </div>' +
                                            '   </div>' +
                                            '</div>';
                                    }
                                } else {
                                    let price_old = _item.price_old == "" || _item.price_old == "0" ? '' : '<del>' + _item.price_old + '</del>';
                                    let count = _item.count > 1 ? '<strong>&nbsp;x&nbsp;' + _item.count + '</strong>' : '';
                                    gifts +=
                                        '<div class="cart__giftadd clearfix" data-selected="' + _item.sku + '">\n';

                                    if (!was_gifts_title) {
                                        gifts += '   <span class="cart__subtitle cart__subtitle-icon cart__subtitle-gift">' + __('Подарунок') + '</span>';
                                        was_gifts_title = true;
                                    }

                                    gifts +=
                                        '   <div class="cart__giftlist">' +
                                        '       <div class="cart__gift cart__gift-sku cart__gift-selected" data-sku="' + _item.sku + '">' +
                                        '           <a href="' + (_item.link == '' ? 'javascript: void(null);' : _item.link) + '" class="cart__giftimage"><img src="' + _item.image + '"></a>' +
                                        '           <a href="' + (_item.link == '' ? 'javascript: void(null);' : _item.link) + '" class="cart__gifttitle">' + (G.manager_logged ? '<strong>[' + _item.sku + ']</strong>&nbsp;' : '') + _item.title + count + '</a>' +
                                        '           <div class="cart__giftprice">' + price_old + _item.price + '&nbsp;грн' + (G.manager_logged ? _item.stock : '') + '</div>' +
                                        '       </div>' +
                                        '   </div>' +
                                        '</div>';
                                }
                            });
                            bundles[item.fired_promo] = false;
                            delete bundles[item.fired_promo];
                        }

                        html += '<div class="cart__item cart__item-promo"><div class="cart__itemadds">' + gifts + '</div></div>';
                    } else {
                        this.current_data.push({
                            'title': item.title,
                            'name': item.name,
                            'id': item.sku,
                            'price': item.price,
                            'brand': item.brand,
                            'category': item.category,
                            'variant': item.variant,
                            'quantity': item.count
                        });

                        let price = '';
                        let code = '';
                        let main_stock = '';
                        let price_old_class = '';

                        if (G.manager_logged || G.b2bmode) {
                            main_stock = item.status ? item.stock : '';
                            if (item.sku)
                                code += '' + item.sku;

                            if (item.price == 0)
                                code += ', <u>Відсутній</u>';
                        }

                        if (item.status) {
                            item.price_curr = item.price == 0.01 ? 'грн' : item.price_curr;
                            price = (!(item.price == '0') ? this.format_price(item.price) + '&nbsp;' + item.price_curr : '');
                            price = (!(item.price_old == "0") ? '<del>' + this.format_price(item.price_old) + '&nbsp;' + item.price_curr + '</del>' : '') + price;
                            price_old_class = (!(item.price_old == "0") ? 'cart__itemprice-promo' : '');
                        } else {
                            if (item.price == 0.01) {
                                price = this.format_price(item.price) + '&nbsp;грн';
                            } else {
                                price = '<span class="noStock">' + __('Немає в наявності') + '</span>';
                                main_stock = '';
                                item.stickers2 = '';
                                item.class = item.class + ' havent';
                            }
                        }

                        if (item.unexisted) {
                            item.class = item.class + ' unexisted';
                            item.link = 'javascript: void(null);';
                        }

                        let in_order = '';
                        let services = '';
                        let services_groups = [];

                        if (Array.isArray(item.services) && item.services.length > 0) {

                            let services_groups_counter = [];
                            let checked_services = 0;

                            let service_count = item.services.length;

                            $.each(item.services, function (i, service) {

                                if (service.group_id > 0) {

                                    if (services_groups_counter[service.group_id] === undefined)
                                        services_groups_counter[service.group_id] = 0;

                                    if (service.checked) {
                                        services_groups_counter[service.group_id]++;
                                        checked_services++;
                                    }

                                } else if (service.checked)
                                    checked_services++;
                            });

                            if (service_count==1 && checked_services==0) {
                                let service = item.services[0];

                                services = `
                                <div class="cart__itemservices cart__itemservices-empty">
                                    <div class="cart__subtitle cart__subtitle-icon cart__subtitle-service cart__subtitle-service-add js-cart__serviceadd">
                                        <input type="hidden" name="services[${item.sku}_${service.group_id}][]"  data-group="${service.group_id}" value="${service.id}" data-added="${service.added}"  class="form-checkbox" />
                                        ${service.title}
                                        <span>${(item.count > 1) ? (item.count + '&nbsp;x&nbsp;' + service.price) : `+${service.price}`}&nbsp;грн</span>
                                    </div>
                                    <div class="cart__services"></div>
                                </div>`;
                            } else {
                                services = '<div class="cart__itemservices ' + (checked_services > 0 ? '' : 'cart__itemservices-empty') + '"><div class="cart__subtitle cart__subtitle-icon cart__subtitle-service ' + (checked_services ? 'cart__subtitle-service-active' : '') + '">' + __('Додаткові пропозиції') + '</div><div class="cart__services ' + (checked_services ? 'cart__services-visible' : '') + '">';

                                $.each(item.services, function (i, service) {
                                    let service_price = service.price;

                                    if (item.count > 1 && (service.checked || (service.group_id && services_groups_counter[service.group_id] > 0)))
                                        service_price = item.count + '&nbsp;x&nbsp;' + service.price;

                                    if (service.group_id > 0 && typeof services_groups[service.group_id] === "undefined") {
                                        services_groups[service.group_id] = false;
                                        services += '<a href="#" class="cart__servicegroup" data-group="' + service.group_id + '">' + service.subgroup_name + '</a>';
                                    }

                                    let service_class = !(typeof service.price_old == "undefined") ? 'red' : '';
                                    let service_description = typeof service.description == "string" && !(service.description == "") ? '<div class="cart__servicedesc hidden">' + service.description + '</div>' : '';
                                    let service_description_icon = typeof service.description == "string" && !(service.description == "") ? '&nbsp;<div class="helpicon"></div>' : '';

                                    services += '<a href="#" class="cart__service js-cart__service ' + (service.group_id ? 'cart__service-radio' : '') + ' ' + (service.checked ? 'cart__service-active' : '') + '">\n' +
                                        '<input type="' + (service.group_id ? 'radio' : 'checkbox') + '" name="services[' + item.sku + '_' + service.group_id + '][]"  data-group="' + service.group_id + '" value="' + service.id + '" data-added="' + service.added + '"  class="form-checkbox" ' + (service.checked ? 'checked' : '') + '>\n' +
                                        '<span class="' + service_class + '">' + service_price + '&nbsp;грн</span><div class="cart__servicetitle">' + service.title + service_description_icon + '</div>' + service_description +
                                        '</a>';
                                });

                                services += '</div></div>';
                            }
                        }

                        if (was_cloop)
                            html += '</div>';

                        let bottom = '';

                        if (G.manager_logged)
                            bottom = '<div class="clearfix mb12"></div>' +
                                '<div class="availability">' + main_stock + '</div>' +
                                '<div class="sku">' +
                                '   Код:&nbsp;<strong>' + code + '</strong>' + item.stickers2 +
                                '</div>';

                        if (G.b2bmode)
                            bottom = '<div class="clearfix mb12"></div>' +
                                '<div class="sku">' +
                                '   Код:&nbsp;<strong>' + code + '</strong>' +
                                '</div>';

                        let gifts = '';

                        if (typeof item.fired_promo === "string" && !(item.fired_promo == "") && typeof bundles[item.fired_promo] === "object") {
                            $.each(bundles[item.fired_promo], (_index, _item) => {
                                _item.bonus = typeof _item.bonus === "number" ? _item.bonus : 0;

                                if (_item.sku == "") {
                                    if (_item.bonus) {
                                        // bonus
                                        let amount = parseInt(_item.price.toString().replace(' ', '') * _item.count);
                                        gifts +=
                                            '<div class="cart__giftadd clearfix">\n'+
                                            '   <span class="cart__subtitle cart__subtitle-icon cart__subtitle-gift">' + __('Бонус') + '</span>' +
                                            '<div class="cart__giftfree cart__giftfree-bonus">' +
                                            '           <a href="javascript: void(null);" class="cart__giftfreetitle">+' + amount + ' ' + __('бонусів на рахунок') + '</a>' +
                                            '           <div class="help">' + __('Витрачай їх на наступну покупку') + '</div>' +
                                            '       </div>' +
                                            '</div>';
                                    } else {
                                        // спецподарок
                                        gifts +=
                                            '<div class="cart__giftadd clearfix">\n' +
                                            '   <div class="cart__giftlist">' +
                                            '       <div class="cart__gift cart__gift-selected">' +
                                            '           <div class="cart__giftimage"><img src="' + _item.image + '"></div>' +
                                            '           <a href="' + (_item.link == '' ? 'javascript: void(null);' : _item.link) + '" class="cart__gifttitle">' + _item.title + '</a>' +
                                            '           <div class="cart__giftprice">' + this.format_price(_item.price) + ' грн' + '</div>' +
                                            '       </div>' +
                                            '   </div>' +
                                            '</div>';
                                    }
                                } else {
                                    let price_old = _item.price_old == "" || _item.price_old == "0" ? '' : '<del>' + _item.price_old + '</del>';
                                    let count = _item.count > 1 ? '<strong>&nbsp;x&nbsp;' + _item.count + '</strong>' : '';
                                    gifts +=
                                        '<div class="cart__giftadd clearfix" data-selected="' + _item.sku + '">\n' + _item.change +
                                        '   <span class="cart__subtitle cart__subtitle-icon cart__subtitle-gift">' + __('Подарунок') + '</span>' +
                                        '   <div class="cart__giftlist">' +
                                        '       <div class="cart__gift cart__gift-sku cart__gift-selected" data-sku="' + _item.sku + '">' +
                                        '           <a href="' + (_item.link == '' ? 'javascript: void(null);' : _item.link) + '" class="cart__giftimage"><img src="' + _item.image + '"></a>' +
                                        '           <a href="' + (_item.link == '' ? 'javascript: void(null);' : _item.link) + '" class="cart__gifttitle">' + (G.manager_logged ? '<strong>[' + _item.sku + ']</strong>&nbsp;' : '') + _item.title + count + '</a>' +
                                        '           <div class="cart__giftprice">' + price_old + _item.price + '&nbsp;грн' + (G.manager_logged ? '<div class="availability">' + _item.stock + '</div>' : '')  + '</div>' +
                                        '       </div>' +
                                        '   </div>' +
                                        '</div>';
                                }

                            });
                            bundles[item.fired_promo] = false;
                            delete bundles[item.fired_promo];
                        }

                        let count = parseInt(item.sku) > 0 ? '<div class="cart__itemcount">' +
                            '           <a href="#" class="minus"></a>' +
                            '           <span class="value">' + item.count + '</span>' +
                            '           <span class="subtitle">' + item.count_title + '</span>' +
                            '           <a href="#" class="plus"></a>' +
                            '       </div>' : '';

                        if (G.b2bmode)
                            count = '<div class="cart__itemcount">' +
                                '<input type="text" name="count" value="' + item.count + '" step="1" placeholder="" />' +
                                '<button class="btn-check hidden"></button>' +
                                '</div>';


                        if (item.comment) {
                            in_order = '<div class="cart__itemorder"><span>' + item.comment + '</span></div>';
                        } else {
                            if (item.in_order)
                                in_order = '<div class="cart__itemorder"><span>' + __('Товар під замовлення') + '</span><span class="days">' + item.in_order + '</span></div>';
                        }

                        if (item.limited) {
                            in_order = `${in_order}<div class="cart__itemlimited"><span>Лише самовивіз</span></div>`;
                        }

                        price = parseInt(item.sku) > 0 ? '<div class="cart__itemprice ' + price_old_class + ' ' + (item.status ? '' : 'cart__itemprice-havent') + '">' + price + '</div>' : '';

                        let promocode = item.promocode ? '<div class="cart__itempromocode">' +
                            '<div class="cart__subtitle cart__subtitle-icon cart__subtitle-promocode">' + __('Промокод') + ':&nbsp;<span>' + item.promocode + '</span></div>' +
                            '<a href="#" class="cart__itempromocoderemove"></a>' +
                            '</div>' : '';

                        let cart__adds = in_order + promocode + services + gifts;

                        let seller = item.seller_name ? `<div class="cart__itemadds"><div class="cart__itemseller ellipsis1">Продавець:&nbsp;<strong>${item.seller_name}</strong></div></div>` : '';

                        html +=
                            '<div class="cart__item ' + item.class + '" data-sku="' + item.sku + '">' + seller +
                            '   <div class="cart__iteminner clearfix">' +
                            '       <a href="#" class="cart__itemremove" data-sku="' + item.sku + '" data-name="' + item.name + '" data-price="' + item.price + '" data-variant="' + item.variant + '" data-brand="' + item.brand + '" data-category="' + item.category + '"></a>' +
                            '       <a class="cart__itemimage" href="' + (item.link ? item.link : 'javascript: void(null)') + '"><img src="' + item.image + '" alt=""></a>' +
                            '       <a href="' + (item.link ? item.link : 'javascript: void(null)') + '" class="cart__itemtitle">' + item.title + '</a>' +
                            (item.allow_upsale ? '<a href="javascript: void(null);" class="cart__itemupsalebtn js-cart__itemupsalebtn">upsale</a>' : '') +
                            '       <div class="cart__itemc">' +
                            price +
                            count +
                            '       </div>' +
                            '       ' + bottom + item.change +
                            '   </div>' + (cart__adds ? '<div class="cart__itemadds">' + cart__adds + '</div>' : '') +
                            '';

                        was_cloop = true;
                    }
                }
            });

            html = html=='' ? '' : html + '</div>';

            $(".cart__items").append(html);

            $(".cart").removeClass('cart-empty').find('.cart__empty').remove();
            $(".cart .empty-message").remove();
        } else {
            $(".cart").addClass('cart-empty').removeClass('cart-openedupsale');
            $(".cart").find('.cart__empty').remove();
            $(".cart__content").append('<div class="cart__empty">' +
                '<h2>' + __('Ваш кошик порожній') + '</h2>' +
                '<p class="mb16">' + __('Додавайте в кошик товари, що сподобалися') + '</p>' +
                '<button class="btn js-cart__close">' + __('Продовжити покупки') + '</button>' +
                '</div>')
            this.hideorderform();
        }

        if (typeof data.sum === "undefined") {

        } else if (typeof data.sum === "object") {

            this.update_fired_promo(data);
            $(".js-cart__topaystring").text(data.toPay);
            this.setSum(data.sum);
            this.set_card_count(data.count_items, data);

            this.timeout = false;

            if (this.clickgopay) {
                $(".cart .go-checkout").trigger('click');
                this.clickgopay = false;
            }

            // payment methods replace
            this.set_payment_methods(data);

            if (G.manager_logged) {
                SLR.SLR.cardHook(data);
            }

            if (G.b2bmode) {
                B2B.B2B.cardHook(data);
            }

            this.show_do_not_call(data.do_not_call, data.do_not_call_checked);
            this.fix_content_height();
        }

        if (!USER.cookie_allowed())
            USER.show_cookie_popup();

        if (typeof callback === 'function')
            callback();
    },

    update_fired_promo: function(data) {
        if (typeof data === "object") {
            if (!(typeof data.fired_promo === "undefined"))
                $(".promo-code-container").replaceWith(data.fired_promo);
        }
        else
            $(".promo-code-container").addClass('hidden');
    },

    load_step: function(stepNumber) {
        if (this.current_step==3) {
            this.save_comment();
        }

        // animation
        $(".scroll-step").empty().addClass('scroll-step-animation');

        return this.postData(
            {
                action: 'basket',
                to: 'step',
                number: stepNumber
            }
        ).then((data) => {
            $(".scroll-step").removeClass('hidden').removeClass('scroll-step-animation').html(data.checkout_steps.html);
            this.current_step = data.checkout_steps.step;
            this.set_checked_header_step(data.checkout_steps.step);
            this.hook_load_step();
        });
    },

    step: function() {
        return this.current_step;
    },

    change_city: function(val) {
        console.log('delivery city id', val);
        let delivery__method = ($(".delivery__method.active").length > 0) ? $(".delivery__method.active input").val() : false;
        $(".selected-method:not(.hidden) .fh66").addClass('cart__warehouse-loading').find('select, .select2').remove();
        $("body.select2-container--open").remove();

        $(".delivery__methods").addClass('delivery__methods-loading');
        $(".delivery__method:not(.hidden-trigger)").removeClass('active').removeClass('hidden');
        $(".delivery__methodchoise").removeClass('hidden');
        $(".delivery__methodhelp").addClass('hidden');
        $(".selected-method").addClass('hidden');
        $(".delivery__choose .alert").addClass('hidden');

        CARD.save_all_delivery(true)
            .then(() => {
                CARD.set_force_update(1);
                CARD.updatePromise().then(() => {
                    $(".delivery__methodchange").trigger('click');
                });
            });
    },

    init_city_choise: function() {
        // new city delivery
        var $search = $('.delivery-city-field');
        var $selectedId = $('.cart [name=delivery_city]');
        var $selectedName = $('.delivery-city-name');
        var $selectedNameShort = $('.delivery-city-shortname');

        $search.typeahead(
            {
                hint: true,
                highlight: true,
                minLength: 3
            },
            {
                name: 'search-results',
                display: 'name', // Відображати поле 'name'
                source: function (query, syncResults, asyncResults) {
                    $.ajax({
                        url: '/aj',
                        data: {
                            term: query,
                            action: 'u',
                            locale: 0,
                            to: 'lookupcity'
                        },
                        type: "POST",
                        dataType: 'json',
                        success: function (data) {
                            asyncResults(data.map(item => {
                                return {
                                    ...item,
                                    name: item.text
                                }
                            }));
                        }
                    });
                },
                limit: 10, // Максимальна кількість варіантів
                rateLimitWait: 1000 // Затримка перед запитом
            }
        );

        $search.on('click', function () {
            // Змінюємо значення поля
            $(this).val($selectedNameShort.val());
            this.focus();
            this.setSelectionRange(0, this.value.length);
        });

        // Обробка вибору елемента
        $search.bind('typeahead:select', function (event, suggestion) {
            // suggestion містить вибраний об'єкт з полями 'id' та 'name'
            // console.log(suggestion);

            if (suggestion) {
                CARD.change_city(suggestion.id)
                $selectedId.val(suggestion.id);
                $selectedName.val(suggestion.title)
                $selectedNameShort.val(suggestion.title)
                $search.val(suggestion.title);
            }
        });
    },

    hook_load_step: function() {
        U.mask_inputs();

        if (U.isMobile()) {
            $(".cart .extra-buttons").empty();

            if ($(".checkout >.scroll:eq(" + (this.step() - 1) + ") .extra-button").length)
                $.each($(".checkout >.scroll:eq(" + (this.step() - 1) + ") .extra-button"), function(i, button) {
                    button = $(button).clone();
                    button.removeClass('hiddenMobile');
                    $(".cart .extra-buttons").append(button.outerHTML());
                });

            this.fix_content_height();
        }

        if ($(".checkout >.scroll:eq(" + (this.step() - 1) + ") select:visible").length)
            $(".checkout >.scroll:eq(" + (this.step() - 1) + ") select:visible").select2({minimumResultsForSearch: Infinity});

        switch(this.step()) {
            case 1:
                setTimeout(function(){
                    $(".cart .auth-form [name=login]").get(0).focus();
                }, 200);

                GTM.fireStatistick('statistick', 'click', $(".js-monocheckout__btn").length > 0 ? 'order_start' : 'order_start', '');

                this.possible_submit_register();
                break;

            case 2:
                this.default_cities_added = false;

                $(".delivery-city select").select2({
                    placeholder: __("Назва населеного пункту..."),
                    minimumInputLength: 0,
                    width: "15em",
                    ajax: {
                        url: '/aj',
                        type: "POST",
                        dataType: "json",
                        data: function (term) {
                            return {
                                term: term['term'],
                                action: 'u',
                                locale: G.locale_id,
                                to: 'lookupcity',
                            };
                        },
                        processResults: function (data, page) {
                            return {
                                results: data
                            };
                        }
                    }
                });

                CARD.init_city_choise();

                this.hook_change_delivery();
                this.trigger_one_delivery_method();
                break;

            case 3:
                this.hide_unavailable_mobile_payment_methods();
                this.update_bonuses();

                if ($(".payment__method-active").length > 0) {
                    let btn = $(".payment__method-active");
                    btn.trigger('click', true);

                    if (btn.data('block')=='credit') {
                        if ($(".credit__listitem-active").length > 0)
                            $(".credit__listitem-active >a").trigger('click');
                    }
                }

                if (this.payment_error_text) {
                    $(".alert-order").html(this.payment_error_text).removeClass('hidden');
                    this.payment_error_text = '';
                }

                break;

            default:
                break;
        }
    },

    load_GA_data: function() {
        if (G.channel!=7) {
            try {
                window.gtag('get', 'G-4TCE34ZT6D', 'session_id', (sessionId) => {
                    // console.log('sessionId', sessionId, document.cookie.match(/_ga_4TCE34ZT6D=([^;]+)/)?.[1].match(/s(\d+)\$/)?.[1]);
                    this.GA_data.session_id = sessionId;
                });

                window.gtag('get', 'G-4TCE34ZT6D', 'client_id', (sessionId) => {
                    this.GA_data.client_id = sessionId;
                });
            } catch (e) {

            }
        }
    },

    // check
    open_checkout: function() {
        return this.postData(
            {
                action: 'basket',
                to: 'orderform',

            }
        ).then((data) => {
            this.set_force_update(0);
            this.set_card_data(data);

            // reset values
            // this.searchcompany_edrpou = '';
            // this.searchcompany_address = '';
            $(".cart-openedupsale").removeClass('cart-openedupsale');
            $(".cart__upsale").remove();

            this.init_checkout_page();
            this.load_GA_data();

            // b2b
            if (G.b2bmode) {
                try {
                    B2B.B2B.open_checkout_hook(data);
                } catch (e) {}
            } else {
                // slr
                if (G.manager_logged) {
                    try {
                        SLR.SLR.open_checkout_hook(data);
                    } catch (e) {}
                } else {
                    let step_to_show = data.checkout_steps.step;

                    if (this.skip_delivery_step && step_to_show==2) {
                        step_to_show = 3;
                    }

                    this.set_checked_header_step(step_to_show);
                    this.load_step(step_to_show);
                }
            }

            this.set_card_count();

            if (USER.is_logged()) {
                GTM.event('checkout_step', 2, 'Користувач був залогінений');
            }

        });
    },

    payment_methods_loader: function(on)
    {
        if (on) {
            $(".cart__paymentouter").empty().addClass('cart__paymentouter-loading');
        } else {
            $(".cart__paymentouter").removeClass('cart__paymentouter-loading');
        }
    },

    hide_payment_error_message: function() {
        $(".alert-order").addClass('hidden');
    },

    clean_payment_method: function()
    {
        this.payment_method = '';
        this.payment_methods_loader(true);

        return this.postData(
            {
                action: 'basket',
                to: 'cleanpaymentmethod',
            }
        ).then(() => {
            $(".js-payment__method:not(.hidden-trigger)").removeClass('payment__method-active').removeClass('hidden');
            $(".payment__methodchoise").removeClass('hidden');
            $(".payment__methodhelp").addClass('hidden');
            $(".payment__data").addClass('hidden');

            this.set_force_update(1);
            this.updatePromise();
        });
    },

    set_payment_method: function(method, forceUpdate = 1) {
        this.payment_method = method;
        this.set_force_update(forceUpdate);

        $(".cart .scroll .error-alert").addClass('hidden');

        switch(method) {
            case 'googlepay':
            case 'applepay':
            case 'googlepay_monobank':
            case 'applepay_monobank':
            case 'applepay_monobank_chrome':
                this.reshow_mobile_payment_buttons();
                break;

            case 'edilo':
                this.show_edilo_payment_buttons();
                break;

            default:
                this.set_default_payment_submit();
                break;
        }

        this.block_checkout(true);

        return this.updatePromise().then(() => {
            this.possible_submit_pay();

            if (G.manager_logged)
                SLR.SLR.paymentHook();
        }).finally(() => {
            this.block_checkout(false);
        });
    },

    set_default_payment_submit: function() {
        this.toggle_order_submit(true);
        $(".for-payment-methods").addClass('hidden');
        $(".submit-cart-pay").removeClass('hidden');
    },

    set_payment_methods: function(data) {

        if (typeof data.payment_methods === "string") {

            this.payment_methods_loader(false);
            $(".cart__paymentouter").html(data.payment_methods);

            if ($(".cart__paymentouter select:visible").length)
                $(".cart__paymentouter select:visible").select2({minimumResultsForSearch: Infinity});

            $(".cart-tabs-content [data-tab=cart] .payment-methods").remove();

            if (typeof data.other_methods === "string" && !(data.other_methods == '')) {
                $(".cart-tabs-content [data-tab=cart] .for-methods-container").html(data.other_methods);
                $(".cart-tabs [data-toggle=cart]").parent().removeClass('hidden');
            } else {
                $(".cart-tabs-content [data-tab=cart]").removeClass('active');
                $(".cart-tabs [data-toggle=cart]").parent().addClass('hidden');
            }

            U.mask_inputs();

            // reset values
            if (this.monobank_phone!='') {
                $(".cart input[name=monobank_phone]").val(this.monobank_phone);
            }

            if (this.abank_phone!='') {
                $(".cart input[name=abank_phone]").val(this.abank_phone);
            }

            $(".pm-data[data-block=cashless] select").select2({minimumResultsForSearch: Infinity});

            if ($(".pm-data[data-block=cashless]").length && !$(".pm-data[data-block=cashless] select").length)
                $(".pm-data[data-block=cashless]").addClass('hidden');

            this.hide_unavailable_mobile_payment_methods();

            if ($(".payment-methods.for-mobile .methods span").length == 0)
                $(".payment-methods.for-mobile").remove();

            this.updateCashlessUserData();

            this.total_overhead = typeof data.total_overhead === "undefined" ? 0 : data.total_overhead;
            this.possible_submit_pay();

            if (G.manager_logged) {
                SLR.SLR.set_payment_methods_hook();
            }
        }
    },

    updateCashlessUserData: function() {
        // console.log('updateCashlessUserData', this.searchcompany_address, this.searchcompany_edrpou);

        if (this.searchcompany_address!='' || this.searchcompany_edrpou!='') {
            $(".js-cart__openaddcompany").trigger('click');

            SEARCHCOMPANY.switch_register_form(this.searchcompany_type);

            $("[name=searchcompany_edrpou]").val(this.searchcompany_edrpou);
            $("[name=searchcompany_address]").val(this.searchcompany_address);
        }
    },

    hide_unavailable_mobile_payment_methods: function() {
        console.log('U.isSafari()', U.isSafari());
        if (U.isSafari()) {
            $(".payment__methoddata .gpay").remove();
        }
    },

    // readonly
    show_readonly: function(readonly) {
        $(".cart").addClass('cart-readonly').removeClass('cart-loader');

        $(".cart__content").append('<div class="cart__readonly"><div>' +
            '<h2>' + __('Очікуємо на оплату') + '</h2>' +
            '<p class="mb16">' + (readonly.payment_method ? (readonly.payment_method) : '') + '</p>' +
            '<button class="btn btn-red js-cart__declinepayment">' + __('Скасувати') + '</button>' +
            '</div></div>');

        // SLR.SLR.show_readonly_hook(readonly);
    },

    // readonly
    hide_readonly: function(readonly) {
        $(".cart").removeClass('cart-readonly');
        $(".cart__readonly").remove();
    },

    readonly_showed: function() {
        return $(".cart").hasClass('cart-readonly');
    },

    get_force_update: function()
    {
        return this.force_update;
    },
    
    set_force_update: function(val)
    {
        this.force_update = val;
    },

    getPaymentMethodData: function()
    {
        let result = {};

        switch(this.payment_method) {
            case 'abank_credit':
                result.months = $(".credit__listitem-active select option:selected").data('months')
                break;

            default:
                break;
        }

        return result;
    },

    setLoading: function(on = true)
    {
        if (on) {
            $(".sku-search input").prop('disabled', true).addClass('loading');
            $(".cart").addClass('cart-loader');
            $(".cart__items").empty();
            $(".js-cart__clienttop").empty();
        } else {
            $(".cart").removeClass('cart-loader');
            $(".sku-search input").prop('disabled', false).removeClass('loading');
        }
    },

    updatePromise: function() {
        this.setLoading();

        return this.postData(
            {
                action: 'basket',
                to: 'update',
                locale: G.locale_id,
                mobile: U.isMobile(),
                force: this.get_force_update(),
                stepNumber: this.step(),
                payment_method: this.payment_method,
                payment_method_data: JSON.stringify(this.getPaymentMethodData())
            }
        ).then((data) => {
            this.set_force_update(0);
            this.set_card_data(data);
            if (typeof data.readonly === "object") {
                this.show_readonly(data.readonly);
            } else {
                this.hide_readonly();
                if (!this.readonly_showed() && this.update_payment_methods()) {
                    $(".cart").removeClass('cart-readonly');
                    $(".cart__readonly").remove();
                    this.set_payment_methods(data);
                }
            }
            this.set_update_payment_methods(true);
            this.block_promocode();
        }).catch(() => {
            this.set_force_update(0);
        }).finally(() => {
            this.setLoading(false);
        });
    },

    set_update_payment_methods: function(val) {
        this._update_payment_methods = val;
    },

    update_payment_methods: function() {
        return this._update_payment_methods;
    },

    // check
    update: function(data, callback){
        this.set_card_data(data, callback);
        this.set_payment_methods(data);

        if (typeof data.readonly === "object") {
            this.show_readonly(data.readonly);
        } else {
            this.hide_readonly();
            if (!this.readonly_showed()) {
                $(".cart").removeClass('cart-readonly');
                $(".cart__readonly").remove();
            }
        }

        return data;
    },

    initApplePay: function() {
        U.loadscript("https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js", () => {

            const showApplePayButton = () => {
                console.log('showApplePayButton');
                $(".for-payment-methods").html(`
                    <button lang="${G.locale_id ? 'ru' : 'uk'}" class="js-cart__pay-applepay hidden-chrome apple-pay-button" style="-apple-pay-button-style: black-outline; -webkit-appearance: -apple-pay-button; -apple-pay-button-type: check-out;" type="button"></button>
                    <button lang="${G.locale_id ? 'ru' : 'uk'}" class="js-cart__pay-applepay hidden-safari apple-pay-button">Оплатити через Pay</button>
                `)
                    .removeClass('hidden');

                $(".submit-cart-pay").addClass('hidden');

                jQuery("body").on('click', '.js-cart__pay-applepay', function (event) {
                    const paymentRequest = {
                        currencyCode: 'UAH',
                        countryCode: 'UA',
                        total: {
                            label: 'Оплата товарів та послуг',
                            amount: CARD.paymentTotal()
                        },
                        merchantCapabilities: ['supports3DS'],
                        supportedNetworks: ['masterCard', 'visa']
                    };

                    const session = new ApplePaySession(3, paymentRequest);

                    session.onvalidatemerchant = function (event) {
                        const promise = validateMerchant(event.validationURL);
                        promise.then(function (merchantSession) {
                            session.completeMerchantValidation(merchantSession);
                        });
                    }

                    function validateMerchant(validationURL) {
                        return new Promise(function (resolve, reject) {

                            $.ajax({
                                type: "POST",
                                url: "/aj",
                                data: {
                                    action: 'u',
                                    to: 'appleverify',
                                    validationURL: validationURL
                                },
                                dataType: "json",
                                timeout: 30000, // in milliseconds
                                success: function (data) {
                                    resolve(data);
                                },
                                error: function (data) {
                                    reject(data);
                                }
                            });
                        });
                    }

                    session.onpaymentauthorized = function (event) {
                        session.completePayment(ApplePaySession.STATUS_SUCCESS);

                        if (typeof event.payment.token.paymentData === "object") {
                            let paymentToken = JSON.stringify(event.payment.token.paymentData);
                            $(".submit-cart-pay").removeClass('hidden');
                            $(".for-payment-methods").addClass('hidden');
                            CARD.payment_data['payment_token'] = paymentToken;
                            CARD.make_order($(".submit-cart-pay").parents('form'));
                        } else
                            console.log('failed payment');
                    }

                    session.begin();
                });
            };

            const hideApplePayButton = () => {
                console.log('hideApplePayButton');
                $(".alert-order").html(__('Вибачте, але у Вас немає можливості оплати через Apple Pay')).removeClass('hidden');
            };

            const merchantId = this.apple_merchant_id;

            ApplePaySession.applePayCapabilities(merchantId)
                .then(capabilities => {
                    console.log('capabilities', capabilities);
                    switch (capabilities.paymentCredentialStatus) {

                        case "paymentCredentialsAvailable":
                            showApplePayButton();
                            break;

                        case "paymentCredentialStatusUnknown":
                            showApplePayButton();
                            break;

                        case "paymentCredentialsUnavailable":
                            hideApplePayButton();
                            break;

                        case "applePayUnsupported":
                            hideApplePayButton();
                            break;
                    }

                    CARD.toggle_order_submit(true);
                    $(".submit-cart-pay").removeClass('loading');
            });
        });
    },

    initGooglePay: function() {
        U.loadscript("https://pay.google.com/gp/p/js/pay.js", function() {
            const gateway = CARD.payment_method=='googlepay_monobank' ?
                {
                    'gateway': 'monobank',
                    'gatewayMerchantId': '18012651359268107575'
                } : {
                    'gateway': 'portmonecom',
                    'gatewayMerchantId': '22236'
                };

            const baseRequest = {
                apiVersion: 2,
                apiVersionMinor: 0
            };
            const allowedCardNetworks = ["MASTERCARD", "VISA"];
            const allowedCardAuthMethods = ["PAN_ONLY", "CRYPTOGRAM_3DS"];
            const tokenizationSpecification = {
                type: 'PAYMENT_GATEWAY',
                parameters: gateway
            };
            const baseCardPaymentMethod = {
                type: 'CARD',
                parameters: {
                    allowedAuthMethods: allowedCardAuthMethods,
                    allowedCardNetworks: allowedCardNetworks
                }
            };
            const cardPaymentMethod = Object.assign(
                {},
                baseCardPaymentMethod,
                {
                    tokenizationSpecification: tokenizationSpecification
                }
            );

            let paymentsClient = null;

            function getGoogleIsReadyToPayRequest() {
                return Object.assign(
                    {},
                    baseRequest,
                    {
                        allowedPaymentMethods: [baseCardPaymentMethod]
                    }
                );
            }

            function getGooglePaymentDataRequest() {
                const paymentDataRequest = Object.assign({}, baseRequest);
                paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
                paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
                paymentDataRequest.merchantInfo = {
                    merchantId: '18012651359268107575',
                    merchantName: 'KTC'
                };
                return paymentDataRequest;
            }

            function getGooglePaymentsClient() {
                if ( paymentsClient === null ) {
                    paymentsClient = new google.payments.api.PaymentsClient({environment: 'PRODUCTION'});
                }
                return paymentsClient;
            }

            function onGooglePayLoaded() {
                const paymentsClient = getGooglePaymentsClient();
                paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest())
                    .then(function(response) {
                        if (response.result) {
                            addGooglePayButton();
                        }
                    })
                    .catch(function(err) {
                        console.error(err);
                    });
            }

            function addGooglePayButton() {
                const paymentsClient = getGooglePaymentsClient();
                const button = paymentsClient.createButton({onClick: onGooglePaymentButtonClicked, buttonColor: 'black'});
                $(".for-payment-methods").removeClass('hidden').empty().append(button);
            }

            function getGoogleTransactionInfo() {
                return {
                    currencyCode: 'UAH',
                    totalPriceStatus: 'FINAL',
                    // set to cart total
                    totalPrice: CARD.paymentTotal()
                };
            }

            function prefetchGooglePaymentData() {
                const paymentDataRequest = getGooglePaymentDataRequest();
                // transactionInfo must be set but does not affect cache
                paymentDataRequest.transactionInfo = {
                    totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
                    currencyCode: 'UAH'
                };
                const paymentsClient = getGooglePaymentsClient();
                paymentsClient.prefetchPaymentData(paymentDataRequest);
            }

            function onGooglePaymentButtonClicked() {
                const paymentDataRequest = getGooglePaymentDataRequest();
                paymentDataRequest.transactionInfo = getGoogleTransactionInfo();

                const paymentsClient = getGooglePaymentsClient();
                paymentsClient.loadPaymentData(paymentDataRequest)
                    .then(function(paymentData) {
                        processPayment(paymentData);
                    })
                    .catch(function(err) {
                        console.error(err);
                    });
            }

            function processPayment(paymentData) {
                let paymentToken = paymentData.paymentMethodData.tokenizationData.token;
                $(".submit-cart-pay").removeClass('hidden');
                CARD.payment_data['payment_token'] = paymentToken;
                CARD.make_order($(".submit-cart-pay").parents('form'));
                $(".for-payment-methods").addClass('hidden');
            }

            onGooglePayLoaded();

        });
    },

    paymentTotal: function() {
        let res = this.sum.deliveryTotal;

        if (this.available_bonuses.amount > 0 && $(".js-cart__usebonus").hasClass('active') && $(".cart__usebonusamount input").val()) {
            res -= $(".cart__usebonusamount input").val();
        }

        if (res < 0) {
            res = 0;
        }

        return res.toString();
    },

    add_buy_in_credit: function(sku, method) {
        $.post(
            '/aj',
            {
                action: 'basket',
                to: 'add',
                update: 1,
                locale: G.locale_id,
                count: 1,
                sku: sku,
            },
            (data) => {
                this.open().then(() => {
                    this.set_payment_method(method)
                        .then(() => {
                            this.open_checkout().then(() => {
                                this.gtm_event_view_cart();
                            });
                        });
                });
            }
        );
    },

    addmany: function(products) {
        const skus = Object.keys(products).join(',');

        Object.values(products).map(item => {
            GTM.event('add_to_cart', item, 'makepc');
            GTM.remarketing('cart', item, 'makepc');
        })

        return this.postData(
            {
                action: 'basket',
                to: 'addmany',
                update: 1,
                sku: skus,
            }).then((data) => {
                this.toggle(true);
        });
    },

    // check
    add: function(sku, opencard, list, gtm, count, callback, callback_update, listname){
        this.sku_was_added = 0;

        const addRequest = (open) => this.postData({
            action: 'basket',
            to: 'add',
            update: 1,
            locale: G.locale_id,
            count: count,
            sku: sku,
        }).then(data => {
            this.firstopened = true;
            this.sku_was_added = data.id;

            GTM.event('add_to_cart', gtm, list);
            GTM.remarketing('cart', gtm, list);

            open = typeof data.disable_notification === "undefined" ? open : 0;

            if (open > 0)
                this.open().then(() => {
                    this.updatePromise().then(() => {
                        this.gtm_event_view_cart();
                    });
                });
            else {
                if (G.is_b2b) {
                    try {
                        WARNING.info(__('Товар додано в <a href="javascript: void(null);" class="typical typical-large js-header__cart">кошик</a>'));
                    } catch(e){};
                }
            }

            this.update(data, callback_update);
            this.hideorderform(1);

            if (typeof callback==="function")
                callback();

            return data.id;
        });
        
        if (G.is_b2b) {
            addRequest();
        } else {
            this.open().then(() => addRequest(false));
        }

    },

    gtm_event_view_cart: function() {
        GTM4N.event(['view_cart']);
    },

    // check
    add_bundle: function(sku) {
        this.sku_was_added = 0;

        return this.open().then(() => {
            this.postData({
                action: 'basket',
                to: 'addbundle',
                update: 1,
                locale: G.locale_id,
                sku: sku.join(',')
            }).then(data => {
                this.firstopened = true;
                this.update(data);
                this.gtm_event_view_cart();
            });
        });
    },

    // check
    remove: function(sku, mainsku, gtm, services, count){
        $.post('/aj',
            {
                action: 'basket',
                to: 'remove',
                locale: G.locale_id,
                update: 1,
                sku: sku,
                mainsku: mainsku,
                count: count,
                mobile: U.isMobile(),
                services: services
            },
            (data) => {
                GTM.event('remove_from_cart', gtm, count);
                this.update(data);
            },
            'json'
        );
    },

    // check
    recount: function(){
        if (!(Cookies.get("c")===undefined))
            $.post(
                '/aj',
                {
                    action: 'basket',
                    to: 'recount',
                    locale: G.locale_id,
                },
                (data) => {
                    this.set_card_count(data.count);
                },
                'json'
            );
    },

    update_count: function(count, sku, services){
        this.timeout = true;

        $.post(
            '/aj',
            {
                action: 'basket',
                to: 'count',
                update: '1',
                locale: G.locale_id,
                count: count,
                sku: sku,
                services: services,
                mobile: U.isMobile()
            },
            (data) => {
                this.update(data);
            },
            'json'
        );
    },

    // check
    monobank_timeout: function() {

        let minutes = parseInt(this.monobank_time / 60, 10)
        let seconds = parseInt(this.monobank_time % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        $(".monobank-approve-form .process-window >span").html(minutes + ':' + seconds);

        this.monobank_time--;

        if (this.monobank_time < 1) {
            clearTimeout(this.monobank_timeout_handler);
            $(".monobank-approve-form .process-window").remove();
            $(".monobank-approve-form").find('.error').removeClass('hidden');
        } else {

            if (this.monobank_time%3==1 && !this.monobank_process) {
                this.monobank_process = true;

                $.post('/aj',
                    {
                        action: 'basket',
                        locale: G.locale_id,
                        to: 'check_monobank_status'
                    },
                    (data) => {
                        this.monobank_process = false;
                        if (data.cancelled) {
                            clearTimeout(this.monobank_timeout_handler);
                            this.monobank_time = 0;
                            $(".monobank_cancel").html(__('Повернутися'));
                            $(".monobank-process >p").remove();
                            $(".process-window").replaceWith('<div class="alert alert-2xgray">' + __('Оплата не отримана!') + '</div>');
                        } else {
                            if (data.success) {
                                clearTimeout(this.monobank_timeout_handler);
                                this.monobank_time = 0;

                                // if (G.manager_logged) {
                                //     SLR.SLR.after_payment_hook();
                                // } else {
                                    $(".cart").removeClass('cart__waiting cart__waiting-portmone');
                                    this.show_thx(this.lead_id);
                                // }
                            }
                        }

                    },
                    'json');
            }

            this.monobank_timeout_handler = setTimeout(() => {
                this.monobank_timeout();
            }, 1000);
        }
    },

    // check
    payparts_timeout: function() {

        let minutes = parseInt(this.monobank_time / 60, 10)
        let seconds = parseInt(this.monobank_time % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        $(".payparts-approve-form .process-window >span").html(minutes + ':' + seconds);

        this.monobank_time--;

        if (this.monobank_time < 1) {
            clearTimeout(this.monobank_timeout_handler);
            $(".payparts-approve-form .process-window").remove();
            $(".payparts-approve-form").find('.error').removeClass('hidden');
        } else {

            if (this.monobank_time%3==1 && !this.monobank_process) {
                this.monobank_process = true;

                $.post('/aj',
                    {
                        action: 'basket',
                        locale: G.locale_id,
                        to: 'check_payparts_status'
                    },
                    (data) => {
                        this.monobank_process = false;
                        if (data.cancelled) {
                            clearTimeout(this.monobank_timeout_handler);
                            this.monobank_time = 0;
                            $(".payparts_cancel").html(__('Повернутися'));
                            $(".payparts-process >p").remove();

                            if (data.status==-2) {
                                $(".process-window").replaceWith('<div class="alert alert-danger">' + __('Кліент банку не знайдений. Ви можете натиснути кнопку "Повернутись", аби спробувати ще раз.') + '</div>');
                            } else {
                                $(".process-window").replaceWith('<div class="alert alert-danger">' + __('Оплата не отримана!') + '</div>');
                            }
                        } else {
                            if (data.success) {
                                clearTimeout(this.monobank_timeout_handler);
                                this.monobank_time = 0;

                                // if (G.manager_logged) {
                                //     SLR.SLR.after_payment_hook();
                                // } else {
                                    $(".cart").removeClass('abank');
                                    this.show_thx(this.lead_id);
                                // }
                            }
                        }

                    },
                    'json');
            }

            this.monobank_timeout_handler = setTimeout(() => {
                this.payparts_timeout();
            }, 1000);
        }
    },

    // check
    abank_timeout: function() {

        console.log('abank timeout');
        let minutes = parseInt(this.monobank_time / 60, 10)
        let seconds = parseInt(this.monobank_time % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        $(".abank-approve-form .process-window >span").html(minutes + ':' + seconds);

        this.monobank_time--;

        if (this.monobank_time < 1) {
            clearTimeout(this.monobank_timeout_handler);
            $(".abank-approve-form .process-window").remove();
            $(".abank-approve-form").find('.error').removeClass('hidden');
        } else {

            if (this.monobank_time%3==1 && !this.monobank_process) {
                this.monobank_process = true;

                $.post('/aj',
                    {
                        action: 'basket',
                        locale: G.locale_id,
                        to: 'check_abank_status'
                    },
                    (data) => {
                        this.monobank_process = false;
                        if (data.cancelled) {
                            clearTimeout(this.monobank_timeout_handler);
                            this.monobank_time = 0;
                            $(".abank_cancel").html(__('Повернутися'));
                            $(".abank-process >p").remove();

                            if (data.status==-2) {
                                $(".process-window").replaceWith('<div class="alert alert-danger">' + __('Кліент банку не знайдений. Ви можете натиснути кнопку "Повернутись", аби спробувати ще раз.') + '</div>');
                            } else {
                                $(".process-window").replaceWith('<div class="alert alert-danger">' + __('Оплата не отримана!') + '</div>');
                            }
                        } else {
                            if (data.success) {
                                clearTimeout(this.monobank_timeout_handler);
                                this.monobank_time = 0;

                                // if (G.manager_logged) {
                                //     SLR.SLR.after_payment_hook();
                                // } else {
                                    $(".cart").removeClass('abank');
                                    this.show_thx(this.lead_id);
                                // }
                            }
                        }

                    },
                    'json');
            }

            this.monobank_timeout_handler = setTimeout(() => {
                this.abank_timeout();
            }, 1000);
        }
    },

    // check
    portmone_timeout: function() {

        let form = $('.portmone-approve-form');

        let minutes = parseInt(this.portmone_time / 60, 10)
        let seconds = parseInt(this.portmone_time % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        $(".process-window >span", form).html(minutes + ':' + seconds);

        this.portmone_time--;

        if (this.portmone_time < 1) {
            clearTimeout(this.monobank_timeout_handler);
            $(".process-window", form).remove();
            form.find('.error').removeClass('hidden');
        } else {

            if (this.portmone_time%3==1 && !this.monobank_process) {
                this.monobank_process = true;

                $.post('/aj',
                    {
                        action: 'basket',
                        locale: G.locale_id,
                        to: 'check_portmone_status'
                    },
                    (data) => {
                        this.monobank_process = false;
                        if (data.cancelled) {
                            clearTimeout(this.monobank_timeout_handler);
                            this.portmone_time = 0;
                            $(".js-portmone_cancel").html(__('Повернутися'));
                            $(".portmone-process >p").remove();
                            $(".process-window").replaceWith('<div class="alert alert-danger">Оплата не отримана!</div>');
                        } else {
                            if (data.success) {
                                clearTimeout(this.monobank_timeout_handler);
                                this.portmone_time = 0;
                                $(".cart").removeClass('abank');
                                this.show_thx(this.lead_id);
                            }
                        }

                    },
                    'json');
            }

            this.monobank_timeout_handler = setTimeout(() => {
                this.portmone_timeout();
            }, 1000);
        }
    },

    submit_order_loading: function(set) {
        if (set) {
            $(".submit-cart-pay").addClass('loading');
        } else {
            $(".submit-cart-pay").removeClass('loading');
        }
    },

    wait_payment_callback_timeout: function() {
        this.wait_callback_time--;

        if (this.wait_callback_time < 1) {
            clearTimeout(this.monobank_timeout_handler);
            // unblock cart
            this.block_checkout(false);
            this.submit_order_loading(false);

            // show error
            $(".js-cart__alertorder").removeClass('hidden').html('Не вдалось отримати оплату. Спробуйте ще раз');

        } else {
            if (this.wait_callback_time%3==1 && !this.monobank_process) {
                this.block_checkout(true);
                this.submit_order_loading(true);
                this.monobank_process = true;

                $.post('/aj',
                    {
                        action: 'basket',
                        locale: G.locale_id,
                        to: 'check_payment_status'
                    },
                    (data) => {
                        this.monobank_process = false;
                        if (data.cancelled) {
                            clearTimeout(this.monobank_timeout_handler);
                            this.wait_callback_time = 0;

                            // unblock cart
                            this.block_checkout(false);
                            this.submit_order_loading(false);

                            // show_error
                            $(".js-cart__alertorder").removeClass('hidden').html('Не вдалось отримати оплату. Спробуйте ще раз');
                        } else {
                            if (data.success) {
                                clearTimeout(this.monobank_timeout_handler);
                                this.wait_callback_time = 0;
                                this.show_thx(this.lead_id);
                            }
                        }

                    },
                    'json');
            }

            this.monobank_timeout_handler = setTimeout(() => {
                console.log('wait_payment_callback_timeout left', this.wait_callback_time);
                this.wait_payment_callback_timeout();
            }, 1000);
        }
    },

    makeOrderHook: function(data, payment) {
        GTM.event('checkout_step', 4, payment);

        let showThx = true;

        if (data.redirect) {
            document.location.assign(data.html);
            return false;
        } else {
            if (data.method=='ccprivat' || data.method=='ccprivat2' || data.method=='ccprivat_visa' || data.method=='ccportmone' || data.method=='ccportmone2' || (data.method_type == 'oschad_payparts' && !G.manager_logged)) {
                console.log('for-payment-methods');
                GTM.event('checkout_step', 4, payment);
                $(".for-payment-methods").html(data.html);
                $(".for-payment-methods [type=submit]").trigger('click');
                return;
            } else {
                if (data.step) {
                    if (data.method_type == 'monobank_payparts' || data.method_type == 'payparts' || data.method_type == 'abank_payparts') {
                        if (data.method_type == 'monobank_payparts') {
                            $(".cart").addClass('monobank');
                            $(".cart .scroll").addClass('hidden');
                            $(".cart .checkout").append(data.html);
                            showThx = false;
                            this.monobank_timeout();
                        } else if (data.method_type == 'payparts') {
                            $(".cart").addClass('payparts');
                            $(".cart .scroll").addClass('hidden');
                            $(".cart .checkout").append(data.html);
                            showThx = false;
                            this.payparts_timeout();
                        } else if (data.method_type == 'abank_payparts') {
                            $(".cart").addClass('abank');
                            $(".cart .scroll").addClass('hidden');
                            $(".cart .checkout").append(data.html);
                            showThx = false;
                            this.abank_timeout();
                        }
                    } else if (data.method == 'ccmonobank' || data.method == 'googlepay' || data.method == 'applepay' || data.method == 'googlepay_monobank' || data.method == 'applepay_monobank' || data.method == 'applepay_monobank_chrome') {
                        const wait_payment_callback = data.stepData.wait_payment_callback ?? false;
                        console.log('wait_payment_callback', wait_payment_callback);

                        if (wait_payment_callback) {
                            // запускаємо таймер відліку, не перемальовуючи кошик.
                            // 3 крок заблокований, очікуємо оплату по callback до 15 секунд. Схоже на очікування оплати частинами
                            // Андрійко таку біду захотів
                            showThx = false;

                            // process payment callback
                            this.wait_callback_time = 15;
                            this.wait_payment_callback_timeout();
                        } else {
                            if (typeof data.stepData === "object" && !(typeof data.stepData.secure_3d === "undefined")) {
                                $(".cart .checkout").append(data.html);
                                $(".cart .checkout .portmone-form").trigger('submit');
                                showThx = false;
                            } else {
                                if (data.html!='' && data.step) {
                                    // чекаємо відповіді від portmone
                                    $(".cart").addClass('cart__waiting cart__waiting-portmone');
                                    $(".cart .scroll").addClass('hidden');
                                    $(".cart .checkout").append(data.html);
                                    this.portmone_timeout();
                                    showThx = false;
                                }
                            }
                        }
                    }
                }
            }
        }

        if (showThx) {
            if (!data.step) {
                GTM.event('purchase', data.order, data.products, USER.is_logged() ? 'Користувач' : 'Без реєстрації');
            }

            $(".cart .checkout").addClass('thx');
            this.set_card_count(0);

            this.google_ask(data);
            this.window('thx', data.html);
            this.firstopened = false;
            this.send_GA(data.order.id, data.order.sum, 'order', data.products);
        }
    },

    make_order: function(parentform){

        this.onorderpage = true;
        this.monobank_time = 600;
        this.portmone_time = 60;

        let params = {
            action: 'basket',
            to: 'order',
            locale: G.locale_id,
            count_items: this.count_items,
            page: document.location.pathname,
            sum: this.sum,
            comment: $(".cart__block-details [name=comment]").val(),
            email: $(".cart__block-details [name=email]").val(),
            ...this.payment_data
        };

        parentform.find('>.alert').addClass('hidden');

        if (!(this.count_items > 0 && (this.sum.uah > 0 || this.sum.usd > 0))) {
            parentform.find('.error-alert').removeClass('hidden').html(__('Перевірте вміст кошика'));
            return;
        }

        params.do_not_call = $(".cart .do-not-call-container").length && !$(".cart .do-not-call-container").hasClass('hidden') && $("[name=do_not_call]").val()==1 ? 1 : 0;

        if ($(".cart .scroll[data-step=2] form [name=delivery]").val()=='novaposhta_postomat')
            $(".cart .scroll[data-step=2] form [name=delivery]").val('novaposhta');

        const payment = $(".cart .checkout [name=payment]").val();
        params.payment = payment;

        this.toggle_order_submit(0);
        parentform.find('[type=submit]').addClass('loading');

        if ($(".cart input[name=monobank_phone]").length > 0) {
            params.monobank_phone = $(".cart input[name=monobank_phone]").val();
        }

        if ($(".cart input[name=abank_phone]").length > 0) {
            params.abank_phone = $(".cart input[name=abank_phone]").val();
        }

        if (params.payment=='cashless') {
            let contractor = '';

            if ($(".cart__searchcompanyresults [name=edrpou]:checked, .cart__searchcompanypredefined [name=edrpou]:checked").length > 0) {
                let el = $(".cart__searchcompanyresults [name=edrpou]:checked, .cart__searchcompanypredefined [name=edrpou]:checked");
                if (el.parent().find('input[type=hidden]').length > 0)
                    contractor = el.parent().find('input[type=hidden]').val();
            }

            params.edrpou = ($(".cart__searchcompanyresults [name=edrpou]:checked, .cart__searchcompanypredefined [name=edrpou]:checked").length > 0 ? $(".cart__searchcompanyresults [name=edrpou]:checked, .cart__searchcompanypredefined [name=edrpou]:checked").val() : '');
            params.contractor = contractor;
            params.searchcompany_edrpou = this.searchcompany_edrpou;
            params.searchcompany_address = this.searchcompany_address;
        }

        // resolution
        params.resolution = `${U.viewportW()}x${U.viewportH()}`;

        // bonuses
        params.use_bonuses = this.available_bonuses.amount > 0 && $(".js-cart__usebonus").hasClass('active') && !$(".cart__usebonus").hasClass('cart__usebonus-loading') && $(".cart__usebonusamount input").val() ? $(".cart__usebonusamount input").val() : 0;

        // google session
        params.google_session = this.GA_data.session_id;
        params.google_client_id = this.GA_client_id();

        // payment data
        params.payment_method_data = JSON.stringify(this.getPaymentMethodData());

        this.block_checkout(true);

        $.ajax({
            type: "POST",
            url: "/aj",
            data: params,
            dataType: "json",
            timeout: this.sent_order_timeout, // in milliseconds
            success: (data) =>  {
                this.block_checkout(false);

                parentform.find('[type=submit]').removeClass('loading');
                this.toggle_order_submit(1);

                if (data.payment_problem) {
                    parentform.find('>.alert').removeClass('hidden').html(data.error);
                    this.onorderpage = false;

                    this.reshow_mobile_payment_buttons();
                    return;
                }

                if (!data.success) {
                    parentform.find('>.alert').removeClass('hidden').html(data.error);
                    this.onorderpage = false;

                    this.reshow_mobile_payment_buttons();
                    return;
                }

                this.makeOrderHook(data, payment);
                this.block_checkout(false);
                return false;
            },
            error: (request, status, err) => {
                parentform.find('[type=submit]').removeClass('loading');
                parentform.find('>.alert').removeClass('hidden').html(__('Щось пішло не так. Спробуйде відправити Ваше замовлення ще раз.'));
                this.onorderpage = false;
                this.toggle_order_submit(1);
                this.block_checkout(false);
            }
        });
    },

    send_GA: function(id, sum, order_type = 'order', products = []) {
        if (G.channel==7) {
            return new Promise((resolve, reject) => {
                resolve();
            });
        } else {
            return this.postData(
                {
                    action: 'basket',
                    to: 'send_ga',
                    id: id
                }).then((data) => {
                if (data.success) {
                    GTM.event('generate_lead', sum, id, order_type, products);
                }
            });
        }

    },

    reshow_mobile_payment_buttons: function(e) {
        if (this.payment_method=='applepay' || this.payment_method=='googlepay' || this.payment_method=='applepay_monobank' || this.payment_method=='googlepay_monobank' || this.payment_method=='applepay_monobank_chrome') {
            if (this.payment_method=='applepay' || this.payment_method=='applepay_monobank' || this.payment_method=='applepay_monobank_chrome') {
                this.toggle_order_submit(false);
                $(".submit-cart-pay").addClass('loading');
                this.initApplePay();
            } else {
                this.initGooglePay();
                $(".submit-cart-pay").addClass('hidden');
            }
        }

        return;
    },

    show_edilo_payment_buttons: function() {
        $(".submit-cart-pay").addClass('hidden');
        U.loadscript("https://web.edilo.com.ua/edilo_integration_form.js", function() {
            const button = $(`<button class="success active js-cart__payedilo" type="button">Подати заявку</button>`);
            $(".for-payment-methods").removeClass('hidden').empty().append(button);
        });
    },

    toggle_order_submit: function(on) {
        if (on) {
            $(".cart .submit-cart-pay").addClass('active').prop('disabled', false).html(__('Підтвердити'));
            this.block_checkout(false);
        }
        else {
            this.block_checkout(true);
            $(".cart .submit-cart-pay").html(__('Очікуйте')).removeClass('active').prop('disabled', true);
        }
    },

    make_order_oneclick: function(phone, name, email){
        return this.postData(
            {
                action: 'basket',
                to: 'order',
                locale: G.locale_id,
                oneclick: 1,
                phone: phone,
                name: name,
                email: email,
                resolution: (U.viewportW() + 'x' + U.viewportH()),
                google_session: this.GA_data.session_id,
                google_client_id: this.GA_client_id()
            }).then((data) => {
                if (data.success) {
                    this.window('process-thx', data.html);
                    $(".cart .checkout").addClass('thx');
                    $(".cart__bottom").append('<button class="cart__close" type="button">' + __('Закрити') + '</button>');
                    this.firstopened = false;
                    GTM.event('checkout_step', 1, 'Замовлення в 1 клік');
                    GTM.event('purchase', data.order, data.products, 'Замовлення в 1 клік');

                    if (G.channel!=7) {
                        this.send_GA(data.order.id, data.order.sum, 'order', data.products);
                    }

                    $(".cart__bottom .make-order").replaceWith('<button class="cart__close" type="button">' + __('Закрити') + '</button>');
                } else {
                    this.update(data);
                }
            });
    },

    set_checked_header_step: function(stepNumber)
    {
        $(".checkout .steps a").removeClass('checked active');
        $(".checkout .steps a:eq(" + (stepNumber - 1) + ")").addClass('active');

        if (stepNumber > 1)
            $(".checkout .steps a:eq(0)").addClass('checked');

        if (stepNumber > 2)
            $(".checkout .steps a:eq(1)").addClass('checked');
    },

    init_checkout_page: function() {
        if ($(".cart >.checkout").length==0) {
            let html = `
                <div class="checkout">
                    <div class="title">Оформлення замовлення</div>
                    <div class="cart__calculate mobileVisible">
                    <span class="delivery"></span>
                    <span class="total"></span>
                    <span class="amount"></span>
                    </div>
                    
                    <div class="steps">
                        <a href="#" class="" data-step="1"><span>Контактна інформація</span></a>
                        <a href="#" class="" data-step="2"><span>Доставка</span></a>
                        <a href="#" class="" data-step="3"><span>Оплата</span></a>
                    </div>
                    
                    <a href="javascript: void(null);" class="cart__close"></a>
                    <a href="javascript: void(null);" class="cart__collapse"></a>
                    
                    <div class="scroll scroll-step"></div>
                    <div class="wrap-wide"></div>
                </div>
            `;

            $(".cart").append(html);
        }

        $(".cart").addClass('process-checkout');
        this.block_promocode();
    },

    block_promocode: function(set) {
        return;
        if ($(".cart").hasClass('process-checkout') && $(".promocode-cart input[name=promocode]").val()!='') {
            $(".promocode-cart input[name=promocode]").prop('disabled', true);
            console.log(`block_promocode ${$(".promocode-cart input[name=promocode]").val()}`);
            return;
        }

        $(".promocode-cart input[name=promocode]").prop('disabled', false);
        console.log('block_promocode false');
    },

    // check
    window: function(addclass, html, opencart = false) {
        $(".cart").addClass("show");
        $(".cart").addClass(addclass);

        if (!$(".cart .checkout").length)
            $(".cart").append('<div class="checkout"></div>');

        $(".cart .checkout").empty().html('<a href="javascript: void(null);" class="cart__close"></a><a href="javascript: void(null);" class="cart__collapse"></a>' + html);

        U.mask_inputs();

        this.block_promocode();
    },

    show_thx: function(id) {
        return this.postData(
            {
                action: 'basket',
                order_id: id,
                to: 'show_thx',
                locale: G.locale_id,
                payed: 1,
            }
        ).then(data => {
            this.google_ask(data);
            this.open();
            this.set_card_data(data);
            this.window('process-thx process-checkout', data.html);
            $(".cart").removeClass('cart-empty').removeClass('cart-loader');
            $(".cart .checkout").addClass('thx');
            $(".cart__bottom").append('<button class="cart__close" type="button">' + __('Закрити') + '</button>');
            this.firstopened = false;

            if (data.products.length)
                GTM.event('purchase', data.order, data.products, USER.is_logged() ? 'Користувач' : 'Без реєстрації');

            this.send_GA(id, data.order.sum, 'order', data.products);
        });
    },

    check_order: function(order_hash) {
        return this.postData(
            {
                action: 'basket',
                to: 'check_status',
                order_hash: order_hash
            }
        ).then((data) => {
            if (data.status=='ok') {
                // показываем благодарочку
                this.show_thx(data.order_id);
            } else {
                this.skip_delivery_step = true;
                this.payment_error_text = data.error;
                this.open().then(() => {
                    this.updatePromise();
                }).then(() => {
                    this.open_checkout();
                });
            }
        });
    },

    // check
    updateFiredPromo: function() {
        let val = [];

        if ($(".fired-container a").not('.active').length)
            $.each($(".fired-container a").not('.active'), function(i, item){
                item = $(item);
                val.push(item.find('input').val());
            });

        val = val.length ? val.join(',') : '';

        $.post(
            '/aj',
            {
                action: 'basket',
                to: 'firedpromo',
                locale: G.locale_id,
                val: val
            },
            (data) => {
                this.onorderpage = true;
                this.set_force_update(1);
                this.updatePromise();
                return false;
            },
            'json'
        );
    },

    // check
    submit_promocode: function(code, placement) {

        if (this.promocode_loading)
            return;

        this.promocode_loading = true;

        this.set_force_update(1);
        $('.promocode').find('.alert').addClass('hidden');

        return this.postData(
            {
                action: 'basket',
                to: 'setpromocode',
                code: code
            }
        ).then((data) => {
            if (data.success) {

                if (placement == 'promo') {
                    document.location.reload();
                } else {
                    this.onorderpage = true;
                    if (!(typeof data.clean_payment === "undefined")) {
                        this.payment_method = '';
                    }
                    this.updatePromise();
                }
            } else {
                $('.promocode').find('.alert').html(data.message).removeClass('hidden');
            }
        }).finally(() => {
            this.promocode_loading = false;
        });
    },

    select_bc_method: function(btn) {
        $(".bc__firstpay").html(btn.data('firstpay') + ' грн');
        $(".bc__nextpay").html(btn.data('nextpay') + ' грн');
        $(".bc__outpay").html(btn.data('outpay') + ' грн');
        $(".bc__totalprice >div").html(btn.data('price') + ' грн');

        $(".bc__totalprice .mobileVisible .price").html(btn.data('price') + ' грн');
        $(".bc__eachpayprice").html(btn.data('nextpay'));
        $(".bc__eachpaymonth").html(btn.text());

        if (btn.data('type')=='full') {
            $(".bc__headerprice").removeClass('bc__headerprice-active');
            $(".bc__headerprice-old").addClass('bc__headerprice-old-active');
        } else {
            $(".bc__headerprice").addClass('bc__headerprice-active');
            $(".bc__headerprice-old").removeClass('bc__headerprice-old-active');
        }

        $(".workdrawer-buy-in-credit input[name=bcmethod]").val(btn.data('method'));
        $(".bc__eachpay").css('opacity', 1);
        $(".bc__help a").removeClass('active');
        $(".bc__help a[data-methods*='|" + btn.data('id') + "|']").addClass('active');

        $(".workdrawer-buy-in-credit [type=submit]").addClass('active');
    },

    cancel_payment: function() {
        return this.postData(
            {
                action: 'basket',
                to: 'cancel_payment',
            }
        ).then(data => {
            if (data.close) {
                this.hide_readonly();
                this.show_thx(this.lead_id);
            } else {
                this.updatePromise()
            }
        });
    }

}

export function init_CARD_events() {
    jQuery(document).ready(function () {

        GTM.event('impressions');

        jQuery("body").on("click", ".cart__close, .js-cart__close", function () {
            CARD.close();
        });

        jQuery("body").on("click", ".js-cart__declinepayment", function (e) {
            e.preventDefault();
            const btn = $(this);
            
            if (!btn.hasClass('disabled')) {
                btn.addClass('disabled btn-loading');
                CARD.cancel_payment().finally(() => {
                    btn.removeClass('disabled btn-loading');
                });
            }
        });

        jQuery("body").on("click", ".cart__collapse", function () {
            let btn = $(this);

            if ($(".cart").hasClass('monobank')) {
                $(".monobank_cancel").trigger('click');
            } else if ($(".cart").hasClass('abank')) {
                $(".abank_cancel").trigger('click');
            } else if ($(".cart").hasClass('payparts')) {
                $(".payparts_cancel").trigger('click');
            } else if ($(".cart").hasClass('cart-openedupsale')) {
                $(".cart").removeClass('cart-openedupsale');
                $(".cart__upsale").remove();
            } else {
                $(".cart").removeClass('process-checkout').removeClass('process-oneclick').find('.checkout').remove();
                $(".cart__bottom .make-order").remove();
                $(".cart .extra-buttons").empty();
            }

            CARD.block_promocode();
        });

        // cart remove
        jQuery("body").on("click touchend", ".cart__itemremove", function (e) {
            e.preventDefault();
            let btn = $(this);
            let cloop = btn.parents('.cart__item');
            let services = [];
            let skus = [];
            let count = cloop.find('.cart__itemcount .value').text();

            skus.push(`${cloop.data('sku')}.${count}`);

            if (cloop.find('.cart__service-active').length > 0)
                $.each(cloop.find('.cart__service-active'), (i, item) => {
                    item = $(item);
                    services.push(`${item.find('input').val()}.${count}`);
                });

            if (cloop.find('.cart__gift-sku').length > 0)
                $.each(cloop.find('.cart__gift-sku'), (i, item) => {
                    item = $(item);
                    skus.push(`${item.data('sku')}.${count}`);
                });

            CARD.remove(skus, cloop.data('sku'), btn.data(), services, count);
            return false;
        });

        // preorder minus plus
        jQuery("body").on("click", ".js-preorderminus, .js-preorderplus", function (e) {
            e.preventDefault();

            const btn = $(this);
            const count = btn.parents('.cart__itemcount');
            let current_val = parseInt(count.data('val'));

            if (btn.hasClass('js-preorderplus')) {
                // plus
                current_val++;
                count.data('val', current_val).find('.value').html(current_val);
            } else {
                // minus
                if (current_val > 1) {
                    current_val--;
                    count.data('val', current_val).find('.value').html(current_val);
                }
            }
        });

        // cart minus
        jQuery("body").on("click", ".cart__item .minus:not(.js-preorderminus)", function (e) {
            e.preventDefault();
            if (CARD.timeout)
                return;

            let cloop = $(this).parents('.cart__item');
            let c = Number(cloop.find('.count .value').html()) - 1;

            if (c < 1)
                return false;

            let services = [];

            if (cloop.find('.cart__service-active').length > 0)
                $.each(cloop.find('.cart__service-active'), (i, item) => {
                    item = $(item);
                    services.push(item.find('input').val());
                });

            CARD.update_count('minus', cloop.data('sku'), services);
            return false;
        });

        // cart plus
        jQuery("body").on("click", ".cart__item .plus:not(.js-preorderplus)", function (e) {
            e.preventDefault();

            if (CARD.timeout)
                return;

            let cloop = $(this).parents('.cart__item');
            let services = [];

            if (cloop.find('.cart__service-active').length > 0)
                $.each(cloop.find('.cart__service-active'), (i, item) => {
                    item = $(item);
                    services.push(item.find('input').val());
                });

            CARD.update_count('plus', cloop.data('sku'), services);
            return false;
        });

        // Кнопка для окрытия диалога выбора подарка
        jQuery("body").on("click", ".cart__giftchange", function (e) {
            e.preventDefault();
            var btn = $(this);
            btn.addClass('hidden');

            var container = btn.parents('.cart__giftadd');

            $.post('/aj', 'action=basket&to=selectgift&locale=' + G.locale_id + '&part_number=' + btn.data('part_number') + '&promotion_id=' + btn.data('promotion_id'), (data) => {

                $.each(data.data, function (index, item) {
                    if (!(item.sku == container.data('selected')))
                        container.find('.cart__giftlist').append(
                            '<div class="cart__gift" data-sku="' + item.sku + '">' +
                            '   <a href="' + item.url + '" class="cart__giftimage">' +
                            '       <img src="' + item.image + '" />' +
                            '   </a>' +
                            '   <a href="' + item.url + '" class="cart__gifttitle">' + (G.manager_logged ? '<strong>[' + item.sku + ']</strong>&nbsp;' : '') + item.title + '</a>' +
                            '   <div class="cart__giftprice"><del>' + item.price + '</del>0.01&nbsp;грн</div>' +
                            '</div>'
                        );
                });

                container.find('.cart__giftlist').addClass('for-chose');
            }, 'json');
        });

        // Выбор конкретного подарка
        jQuery("body").on("click", ".cart__giftlist.for-chose .cart__gift", function (e) {
            e.preventDefault();
            let btn = $(this);
            let container = btn.parents('.cart__giftadd');
            let change = container.find('.cart__giftchange');

            $.post(
                '/aj',
                {
                    action: 'basket',
                    to: 'changegift',
                    locale: G.locale_id,
                    update: 1,
                    oldsku: container.data('selected'),
                    sku: btn.data('sku'),
                    promotion_id: change.data('promotion_id')
                },
                (data) => {
                    CARD.updatePromise();
                },
                'json'
            );
        });

        // Go Checkout
        jQuery("body").on("click", ".cart .go-checkout", function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (CARD.count_items > 0 && (CARD.sum.uah > 0 || CARD.sum.usd > 0)) {
                GTM.event('checkout_step', 1, 'Замовити');
                CARD.open_checkout();
            }

            return false;
        });

        // Go One Click
        jQuery("body").on("click", ".btn-oneclick", function (e) {
            e.preventDefault();

            if (CARD.count_items > 0) {
                GTM.event('checkout_step', 1, 'Замовити');

                let btn = $(this);
                let form = btn.parents('form');
                let phone = form.find('[name=login]');
                let digits = phone.val().replace(/[^0-9.]/g, "");

                if (digits.length == 10) {
                    if (USER.codeAllowed(digits)) {
                        CARD.onorderpage = true;
                        form.find('.btn-oneclick').addClass('loading');
                        CARD.updatePromise().then(() => {
                            CARD.onorderpage = false;
                            CARD.make_order_oneclick(
                                phone.val(),
                                (form.find('[name=name]').length > 0 ? form.find('[name=name]').val() : ''),
                                (form.find('[name=email]').length > 0 ? form.find('[name=email]').val() : '')
                            );
                            form.find('.alert').addClass('hidden');
                        });
                    } else {
                        form.find('.alert').removeClass('hidden').html(__('Введіть номер телефону в правильному форматі.'));
                    }
                } else {
                    form.find('.alert').removeClass('hidden').html(__('Введіть Ваш номер телефону для продовження.'));
                }
            }
        });

        // Submit One Click
        jQuery("body").on("submit", ".process-oneclick .checkout form", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var form = $(this);
            var phone = form.find('[name=login]');
            var digits = phone.val().replace(/[^0-9.]/g, "");

            if (digits.length == 9) {
                CARD.onorderpage = true;
                CARD.updatePromise()
                    .then(() => {
                            CARD.onorderpage = false;
                            CARD.make_order_oneclick(phone.val(), form.find('[name=name]').val(), form.find('[name=email]').val());
                            form.find('.form-item .error').addClass('hidden');
                        }
                    );
            } else {
                form.find('.form-item .error').removeClass('hidden');
            }

            return false;
        });

        // Submit One Click Mobile
        jQuery("body").on("click touchend", ".process-oneclick .bottom .make-order", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".process-oneclick .checkout form").trigger('submit');

            return false;
        });

        // Submit One Click Mobile
        jQuery("body").on("click", ".checkout .steps a, .submit-cart-register", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            CARD.go_step(btn.data('step'));
            return false;
        });

        // step 1
        jQuery("body").on("change", ".tform-auth [name=unregistered]", function (e) {
            var input = $(this);
            Cookies.set("guest_unregistered", input.prop('checked') ? 1 : 0, {
                path: '/'
            });
            CARD.possible_submit_register();
        });

        // Клик выбора услуги
        jQuery("body").on("click", ".js-cart__service", function (e) {
            e.preventDefault();
            let target = $(e.target);
            let btn = $(this);

            if (target.hasClass('helpicon')) {
                let opened = btn.find('.cart__servicedesc').hasClass('hidden') ? 0 : 1;
                btn.parent().find('.cart__servicedesc').addClass('hidden');

                if (!opened)
                    btn.find('.cart__servicedesc').removeClass('hidden');

                return;
            }

            let was = [];
            let after = [];

            let cart_services = btn.parent();
            let count = btn.parents('.cart__item').find('.cart__itemcount .value').text();
            let checked_count = 0;

            if (btn.hasClass('cart__service-group')) {
                if (btn.hasClass('cart__service-active')) {
                    btn.parents('.cart__item').find('.cart__service-sub.cart__service-active input[data-group=' + btn.data('group') + ']').parent().trigger('click');
                    btn.removeClass('cart__service-active');
                } else
                    btn.parents('.cart__item').find('.cart__service-sub input[data-group=' + btn.data('group') + ']').first().parent().trigger('click');
                return;
            }

            $.each(cart_services.find('a'), function (i, label) {
                label = $(label);
                let input = label.find('input');

                if (input.prop('checked'))
                    checked_count++;

                // if (input.prop('checked') && input.data('added')=='0')
                if (input.prop('checked'))
                    was.push(input.val());
            });

            let input = btn.find('input');

            if (checked_count && input.data('group'))
                count = btn.parents('.cart__item').find('.cart__itemcount .value').text();

            if (input.prop('checked')) {
                input.prop('checked', false);
                count = btn.parents('.cart__item').find('.cart__itemcount .value').text();
                btn.removeClass('cart__service-active');
            } else {
                if (input.data('cart__service-group'))
                    cart_services.find('input[data-group=' + input.data('group') + ']').prop('checked', false);

                input.prop('checked', true);
                btn.addClass('cart__service-active');
            }

            $.each(cart_services.find('a'), function (i, label) {
                label = $(label);
                let input = label.find('input');
                if (input.prop('checked'))
                    after.push(input.val());
            });

            if (btn.hasClass('sub'))
                btn.parents('.cart__item').find('.cart__service-group[data-group=' + input.data('group') + ']').addClass('cart__service-active');

            CARD.add_service(btn.parents('.cart__item').data('sku'), was, after, count);
        });

        // Клик возврата к методам доставки
        jQuery("body").on("click", ".delivery__methodchange", function (e) {
            e.stopPropagation();
            e.preventDefault();

            $(".delivery__methods").addClass('delivery__methods-loading');
            $(".delivery__method:not(.hidden-trigger)").removeClass('active').removeClass('hidden');
            $(".delivery__methodchoise").removeClass('hidden');
            $(".delivery__methodhelp").addClass('hidden');
            $(".selected-method").addClass('hidden');
            $(".delivery__choose .alert").addClass('hidden');

            CARD.save_all_delivery(true).then(() => {
                CARD.update_delivery_methods().then(() => {
                    ANOTHERRECIPIENT.trigger_show();
                    CARD.possible_submit_delivery();
                });
            });
        });

        // Клик выбора метода доставки (desktop)
        jQuery("body").on("click", ".delivery__method", function (e) {
            e.stopPropagation();
            e.preventDefault();
            let label = $(this);
            let input = label.find('input');
            let value = input.val();

            $(".cart .scroll .error-alert").addClass('hidden');
            $(".delivery__methodchoise").addClass('hidden');
            $(".delivery__methodhelp").removeClass('hidden');
            $(".delivery__method").removeClass('active');
            label.addClass('active');
            label.parent().find('.delivery__method').not(label).addClass('hidden');

            $(".selected-method").addClass('hidden');
            $(".selected-method[data-name=" + value + "]").removeClass('hidden');

            input.prop('checked', true);

            CARD.save_all_delivery().then(() => {
                CARD.hook_change_delivery();
            });
            return;
        });

        // change delivery city
        jQuery("body").on("change", ".1cart [name=delivery_city]", function (e, isTriggered) {

            console.log('delivery city id', $(this).val());

            e.preventDefault();
            isTriggered = isTriggered ? isTriggered : false;
            let val = $(this).val();

            console.log('delivery city id', val);
            let delivery__method = ($(".delivery__method.active").length > 0) ? $(".delivery__method.active input").val() : false;
            $(".selected-method:not(.hidden) .fh66").addClass('cart__warehouse-loading').find('select, .select2').remove();
            $("body.select2-container--open").remove();

            $(".delivery__methods").addClass('delivery__methods-loading');
            $(".delivery__method:not(.hidden-trigger)").removeClass('active').removeClass('hidden');
            $(".delivery__methodchoise").removeClass('hidden');
            $(".delivery__methodhelp").addClass('hidden');
            $(".selected-method").addClass('hidden');
            $(".delivery__choose .alert").addClass('hidden');

            CARD.save_all_delivery(true)
                .then(() => {
                    CARD.set_force_update(1);
                    CARD.updatePromise().then(() => {
                        $(".delivery__methodchange").trigger('click');
                    });
                });
        });

        // change self store
        jQuery("body").on("click", ".selected-method[data-name=self] .for-store label:not(.disabled)", function (e) {
            e.preventDefault();
            let label = $(this);
            console.log(1);
            let input = $(this).find('input');
            $(".selected-method[data-name=self] [name=store]").val(input.val());
            $(".selected-method[data-name=self] .checkbox-list label").removeClass('active');
            label.addClass('active');
            CARD.possible_submit_delivery();
        });

        var novaposhta_warehouse_loading = false;

        // change street
        jQuery("body").on("change", ".selected-method .for-address-select select", function (e) {
            let el = $(this);
            el.parent().data('val', el.val());
            CARD.possible_submit_delivery();
        });

        // change postomat
        jQuery("body").on("change", ".selected-method select[name=npostomat]", function (e) {
            CARD.possible_submit_delivery();
        });

        // change cashless contractor city
        jQuery("body").on("change", ".payment__data[data-block=cashless] select", function (e) {
            let val = $(this).val();
            CARD.save_fields('contractor', val);
        });

        // change novaposhta warehouse
        jQuery("body").on("change", ".selected-method[data-name=novaposhta] .for-warehouse select", function (e) {
            let val = $(this).val();
            $(".selected-method[data-name=novaposhta] .for-warehouse").data('selected', val);

            let hide_selfpay = false;
            let show_error = false;
            let text = $(".selected-method[data-name=novaposhta] select[name=nwarehouse] option:selected").text();

            if (text.substring(0, 8) == 'Поштомат' || text.substring(0, 8) == 'Почтомат') {
                hide_selfpay = true;
                show_error = !CARD.check_postomat_overprice();
            }

            CARD.show_error_postomat_overprice(show_error);

            if (hide_selfpay)
                $(".js-payment__method.onself").addClass('hidden');
            else
                $(".js-payment__method.onself").removeClass('hidden');

            CARD.possible_submit_delivery();
        });

        // change novaposhta_postomat warehouse
        jQuery("body").on("change", ".selected-method[data-name=novaposhta_postomat] .for-warehouse select", function (e) {
            let val = $(this).val();
            $(".selected-method[data-name=novaposhta_postomat] .for-warehouse").data('selected', val);
            CARD.possible_submit_delivery();
        });

        // change shop delivery  warehouse
        jQuery("body").on("change", ".selected-method[data-name=shop_delivery] .for-warehouse select", function (e) {
            let val = $(this).val();
            $(".selected-method[data-name=shop_delivery] .for-warehouse").data('selected', val);
            CARD.possible_submit_delivery();
        });

        // change urkpost warehouse
        jQuery("body").on("change", ".selected-method[data-name=ukrpost] .for-warehouse select", function (e) {
            let btn = $(this);
            let val = btn.val();
            CARD.possible_submit_delivery();
        });

        // change urkpost warehouse
        jQuery("body").on("keyup", ".selected-method input.for-house", function (e) {
            CARD.possible_submit_delivery();
        });

        // step 2 submit
        jQuery("body").on("click", ".cart .submit-cart-delivery", function (e) {
            e.preventDefault();
            let btn = $(this);
            let form = btn.parents('form');
            let address_container = form.find('.selected-method:not(.hidden)');

            if (!btn.hasClass('loading')) {

                if (!CARD.possible_submit_delivery()) {
                    form.find('.alert').html(CARD.delivery_error_text()).removeClass('hidden');
                } else {
                    form.find('.alert').addClass('hidden');

                    let promises = [];

                    // save last name
                    let address_container = $('.delivery__choose .selected-method:not(.hidden)');

                    if (address_container.find('[name=first_name]').length > 0) {
                        let name = [];

                        name.push(address_container.find('[name=first_name]').val());
                        name.push(address_container.find('[name=middle_name]').val());

                        if (address_container.find('[name=last_name]').length > 0) {
                            name.push(address_container.find('[name=last_name]').val());
                        }

                        promises.push(CARD.postData({
                            action: 'basket',
                            to: 'update_user_name',
                            name: name.join(' ')
                        }));
                    } else {
                        if (address_container.find('[name=last_name]').length > 0)
                            if (address_container.find('[name=last_name]').val()) {

                                promises.push(CARD.postData({
                                    action: 'users',
                                    to: 'updatelastname',
                                    locale: G.locale_id,
                                    last_name: address_container.find('[name=last_name]').val(),
                                }));
                            }
                    }

                    btn.addClass('loading');

                    Promise.all(promises).then(() => {
                        CARD.save_all_delivery()
                            .finally(() => {
                                if (CARD.delivery.delivery_title) {
                                    console.log('checkout_step', CARD.delivery.delivery_title);
                                    GTM.event('checkout_step', 3, 'Доставка', CARD.delivery.delivery_title);
                                }

                                CARD.updatePromise()
                                    .finally(() => {
                                        btn.removeClass('loading');

                                        CARD.go_step(3).then(() => {
                                            if (!(!G.manager_logged && $(".cart .scroll[data-step=1] input[name=email]").length && $.trim($(".cart .scroll[data-step=1] input[name=email]").val()) == '') || USER.is_logged())
                                                if (!$(".cart-tabs a[data-toggle=details]").parent().hasClass('active'))
                                                    $(".cart-tabs a[data-toggle=details]").trigger('click');
                                            //
                                            // if (!CARD.possible_do_not_call()) {
                                            //     $(".do-not-call-container a").removeClass('active');
                                            //     $(".cart [name=do_not_call]").val(0);
                                            // }
                                            //
                                            // if (CARD.show_do_not_call_value)
                                            //     CARD.show_do_not_call(true);

                                            CARD.possible_submit_pay();
                                        });
                                    });
                            });
                    });


                }
            }
            return;
        });

        // услуги свернуть
        jQuery("body").on("click", ".cart__subtitle-service:not(.js-cart__serviceadd)", function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.toggleClass('cart__subtitle-service-active');
            btn.next().toggleClass('cart__services-visible');
            return;
        });

        //
        jQuery("body").on("click", ".js-cart__serviceadd", function (e) {
            e.preventDefault();
            let btn = $(this);
            CARD.add_service(btn.parents('.cart__item').data('sku'), [], [btn.find('input').val()], btn.parents('.cart__item').find('.cart__itemcount .value').text());
        });

        // показать дополнительные методы оплаты
        jQuery("body").on("click", ".cart .more-methods", function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.toggleClass('active');
            $(".cart .additional-methods").toggleClass('hidden');
            return;
        });

        // показать дополнительные функции на 3-ем шаге оформления заказа
        jQuery("body").on("click", ".cart .more-functions", function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.toggleClass('active');
            $(".cart .order-data").toggleClass('hidden');

            CARD.more_functions_opened = btn.hasClass('active') ? true : false;
        });

        // Клик возврата к методам оплаты
        jQuery("body").on("click", ".payment__methodchange", function (e) {
            e.stopPropagation();
            e.preventDefault();

            CARD.clean_payment_method();
            CARD.set_default_payment_submit();
            CARD.hide_payment_error_message();
        });

        // выбор платежного метода
        jQuery("body").on("click", ".js-payment__method", function (e) {
            e.preventDefault();
            let btn = $(this);
            let set_payment = false;

            if (btn.hasClass('payment__method-rest')) {
                e.stopPropagation();
                return false;
            }

            let skip_force_update = arguments[1] ?? 0;

            $(".payment__methodhelp").removeClass('hidden');
            $(".js-payment__method").removeClass('payment__method-active').addClass('hidden');
            CARD.hide_payment_error_message();
            $(".payment__data:not([data-name=" + btn.data('block') + "])").addClass('hidden');
            btn.addClass('payment__method-active').removeClass('hidden');

            switch (btn.data('block')) {
                case 'innp':
                case 'inshop':
                case 'oncard':
                case 'cashless':
                case 'edilo':
                    set_payment = btn.data('block');
                    break;

                case 'mobile':
                case 'ccmonobank':
                case 'ccmonobank2':
                case 'cart':
                case 'ccprivat2':
                case 'ccprivat_visa':
                case 'ccportmone2':
                case 'cashpromo':
                case 'cashpromo2':
                    set_payment = btn.find('.payment__methoddata >div').data('method');
                    break;

                case 'credit':
                    $(".payment__data[data-block=credit]").removeClass('hidden');
                    break;

                default:
                    break;
            }

            console.log('set_payment', set_payment);

            if (set_payment && !CARD.readonly_showed())
                CARD.set_payment_method(set_payment, skip_force_update ? 0 : 1);
        });

        // выбор кредитной группы
        jQuery("body").on("click", ".cart .credit__listitem >a", function (e) {
            e.preventDefault();
            let btn = $(this);
            $('.credit__listitem-active').removeClass('credit__listitem-active');
            btn.parent().addClass('credit__listitem-active');
            btn.parent().find('select').select2({
                minimumResultsForSearch: Infinity
            }).trigger('change');

            if (btn.parent().find('[name=login]').length)
                btn.parent().find('[name=login]').val($(".cart [name=login]").val());
        });

        // выбор платежного метода онлайн
        jQuery("body").on("click", ".cart .payment__data[data-block=cart] .pm-list a", function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.parent().find('a').removeClass('active');
            btn.addClass('active');
            CARD.set_payment_method(btn.data('method'));
        });

        // выбор конкретного кредитного метода
        jQuery("body").on("change", ".cart .credit__list select", function (e) {
            e.preventDefault();
            let select = $(this);
            let option = select.find('option:selected');
            let container = select.parents('.credit__list');

            let payment_method = option.val();

            container.find('.gray').html(option.data('description'));
            container.find('.per-month span').html(option.data('permonth') + '&nbsp;' + __('грн/міс'));
            container.find('.overprice span').html(option.data('overprice') + '&nbsp;грн');

            CARD.set_payment_method(payment_method, true);
        });

        //
        jQuery("body").on("click", ".cart__blockclose", function (e) {
            e.preventDefault();
            $(".cart__block-active").removeClass('cart__block-active');
            $(".typical2-details, .typical2-promo").removeClass('typical2-active');
        });

        jQuery("body").on("click", ".typical2-details", function (e) {
            e.preventDefault();
            let was = $(this).hasClass('typical2-active');
            $(".cart__blockclose").trigger('click');

            if (!was) {
                $(this).addClass('typical2-active');
                $(".cart__block[data-tab=details]").toggleClass('cart__block-active');
                $(".cart__block-details [name=comment]").focus();
            }
        });

        jQuery("body").on("click", ".typical2-promo", function (e) {
            e.preventDefault();
            let was = $(this).hasClass('typical2-active');
            $(".cart__blockclose").trigger('click');

            if (!was) {
                $(this).addClass('typical2-active');
                $(".cart__block[data-tab=promo]").toggleClass('cart__block-active');
            }
        });

        // тушим кнопку гугла, когда идет загрузка
        jQuery("body").on("click", ".googlepay-container.loading button", function (e) {
            e.preventDefault();
        });

        // не звоните мне
        jQuery("body").on("click", ".cart .do-not-call-container a", function (e) {
            e.preventDefault();
            let btn = $(this);

            btn.addClass("user-clicked");

            if (btn.hasClass('active')) {
                btn.removeClass('active');
                $(".cart [name=do_not_call]").val(0);
            } else {
                btn.addClass('active');
                $(".cart [name=do_not_call]").val(1);
            }
        });

        // Personal Promotions
        jQuery("body").on("click", ".js-cart__personalpromo", function (e) {
            e.preventDefault();

            CARD.postData({
                action: 'basket',
                to: 'removepersonalpromo'
            }).then(() => {
                CARD.updatePromise();
            })
        });

        // Promocode открыть форму, первый экран корзины
        jQuery("body").on("click", ".cart__promocodebtn", function (e) {
            e.preventDefault();
            $(".promocode-cart").removeClass('hidden');
            $(".promocode-cart .promocode__submit").removeClass('hidden');
            $(".promocode-cart .promocode__removecartbottom").addClass('hidden');
            $(".promocode-cart [name=promocode]").val('');
            $(this).addClass('hidden');
            CARD.fix_content_height();
        });

        // Promocode закрыь ошибку
        jQuery("body").on("click", ".alert-promocode", function (e) {
            e.preventDefault();
            $(this).remove();
        });

        // Promocode Удалить промокод, первый экран корзины
        jQuery("body").on("click", ".cart__itempromocoderemove", function (e) {
            e.preventDefault();
            e.stopPropagation();
            CARD.removePromocode();
        });

        // Promocode Удалить промокод
        jQuery("body").on("click", ".delete-promocode", function (e) {
            e.preventDefault();
            e.stopPropagation();
            CARD.removePromocode();
        });

        // Promocode Удалить промокод (страница акции)
        jQuery("body").on("click", ".promocode__remove", function (e) {
            e.preventDefault();
            e.stopPropagation();
            CARD.removePromocode().then(() => {
                document.location.reload();
            });
        });

        // Promocode Удалить промокод (корзина первый экран)
        jQuery("body").on("click", ".promocode__removecartbottom", function (e) {
            e.preventDefault();
            e.stopPropagation();
            CARD.removePromocode();
        });

        // Promocode Выбрать существующий промокод
        jQuery("body").on("click", ".possible-promocode-form a", function (e) {
            e.preventDefault();

            let select = $(this);

            if (select.hasClass('active')) {
                CARD.removePromocode();
            } else {
                let code = select.find('input').val();

                if ($.trim(code) == '')
                    $(".delete-promocode").trigger('click');
                else
                    CARD.submit_promocode(code);
            }
        });

        // Promocode submit form
        jQuery("body").on("keydown", ".cart [name=promocode]", function (e) {
            if (event.which == 13) {
                e.preventDefault();
                e.stopPropagation();
                $(".submitPromoCode").trigger('click');
                return;
            }
        });

        // Promocode keyup
        jQuery("body").on("keyup", ".promocode-cart [name=promocode]", function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                $(".promocode-cart .promocode__submit").trigger('click');
                return;
            }
        });

        // Promocode Сохранить промокод
        jQuery("body").on("click", ".promocode__submit", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            let container = btn.parents('.promocode');
            console.log('.promocode__submit');
            CARD.submit_promocode($("[name=promocode]", container).val(), container.hasClass('promocode-cart') ? 'cart' : 'promo');
        });

        jQuery("body").on("click", ".open-possible-promocode", function (e) {
            e.preventDefault();

            var btn = $(this);
            btn.find('i').toggleClass('fa-chevron-down').toggleClass('fa-chevron-up');
            $(".possible-promocode-form").toggleClass('hidden');
        });

        // click fired promos
        jQuery("body").on("click", ".fired-container a", function (e) {
            e.preventDefault();
            var btn = $(this);
            var input = btn.find('input');
            var val = input.val();

            if (btn.parent().hasClass('possible-promocode-form'))
                return;

            if (val == 0) {
                $.each($(".fired-container input").not('[val=0]'), function (i, item) {
                    var item = $(item);

                    if (btn.hasClass('active')) {
                        item.prop('checked', true);
                        item.parent().addClass('active');
                    } else {
                        item.prop('checked', false);
                        item.parent().removeClass('active');
                    }
                });
            } else {
                $(".fired-container input[value=0]").prop('checked', false).parent().removeClass('active');
            }

            if (btn.hasClass('active')) {
                btn.removeClass('active');
                btn.find('input').prop('checked', false);
            } else {
                btn.addClass('active');
                btn.find('input').prop('checked', true);
            }

            CARD.updateFiredPromo();
        });

        // Отправка заказа
        jQuery("body").on("click", ".submit-cart-pay", function (e) {
            e.preventDefault();

            let btn = $(this);

            CARD.searchcompany_address = $("[name=searchcompany_address]").length > 0 ? $("[name=searchcompany_address]").val() : '';
            CARD.searchcompany_edrpou = $("[name=searchcompany_edrpou]").length > 0 ? $("[name=searchcompany_edrpou]").val() : '';

            CARD.possible_submit_pay(true);

            if (!(!btn.hasClass('active') || btn.hasClass('loading'))) {

                let form = btn.parents('form');
                btn.addClass('loading');
                CARD.set_force_update(true);
                CARD.set_update_payment_methods(false);
                CARD.update_visible_data()
                    .then(() => {
                        CARD.block_checkout(false);
                        CARD.make_order(form)
                    })
                    .catch((error) => {
                        btn.removeClass('loading');
                        form.find('>.alert').removeClass('hidden').html(error);
                    })
                    .finally(() => {
                    });
            }
        });

        // Открываем акции
        jQuery("body").on("click touchend", ".fired-container >label", function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('opened');
        });

        // comment
        jQuery("body").on("keyup", ".cart textarea[name=comment]", function (e) {
            // if (!$(".do-not-call-container").hasClass('hidden')) {
            //     CARD.show_do_not_call(false);
            // }
        });

        // monobank_phone
        jQuery("body").on("keyup", ".cart input[name=monobank_phone]", function (e) {
            CARD.monobank_phone = $(this).val();
        });

        // abank_phone
        jQuery("body").on("keyup", ".cart input[name=abank_phone]", function (e) {
            CARD.abank_phone = $(this).val();
        });

        // write preorder
        jQuery("body").on("keyup change", ".form-preorder input", function (e) {
            let form = $(this).parents('.form-preorder');

            let active = false;

            if (G.is_b2b) {
                active = true;
            } else {
                let phone = $("[name=login]", form).val();

                if ($.trim(form.find('[name=name]').val())!='' && phone.replace(/\D/g,'').length==10) {
                    active = true;
                }
            }

            if (active) {
                form.find('[type=submit]').addClass('active');
            } else {
                form.find('[type=submit]').removeClass('active');
            }
        });

        // write check availability
        jQuery("body").on("keyup", ".form-checkav input", function (e) {
            let form = $(this).parents('.form-checkav');

            if ($.trim(form.find('[name=name]').val()) == '' || $.trim(form.find('[name=phone]').val()) == '')
                form.find('[type=submit]').removeClass('active');
            else
                form.find('[type=submit]').addClass('active');
        });

        // Предзаказ
        jQuery("body").on("click", ".js-preorder__submit", function (e) {
            e.preventDefault();
            let btn = $(this);

            if (btn.hasClass('active')) {
                CARD.submit_preorder();
            }
        });

        // Предзаказ
        jQuery("body").on("click", ".js-preorder__submitcontinue", function (e) {
            e.preventDefault();
            let btn = $(this);
            let to = btn.data('to');

            if (btn.prop('disabled'))
                return;

            if (btn.hasClass('active')) {
                let form = btn.parents('form');

                if (G.manager_logged) {
                    CARD.submit_preorder();
                } else {
                    switch(to) {
                        case 'checksms':
                            let data = {};
                            data.action = 'u';
                            data.to = 'checkcode';
                            data.save_phone = 0;
                            data.token = USER.token;
                            data.phone = form.find('[name=login]').val().replace(/\D/g, '');
                            data.code = form.find('[name=codesms]').val().replace(/\D/g, '');

                            btn.addClass('active');

                            $.ajax({
                                    type: "POST",
                                    url: "/aj",
                                    data: data,
                                    dataType: "json",
                                    timeout: 15000, // in milliseconds
                                    success: result => {
                                        if (result.error) {
                                            form.find('.alert').addClass('alert-danger').removeClass('hidden').html(result.error);
                                        } else {
                                            btn.prop('disabled', true);
                                            CARD.submit_preorder();
                                        }
                                    },
                                    error: res => {
                                        form.find('.alert').addClass('alert-danger').removeClass('hidden').html('Помилка. Спробуйте ще раз');
                                        btn.prop('disabled', false);
                                    }
                                }
                            );
                            break;

                        default:
                            $(".help-confirm, .resend-buttons, [type=submit], .for-sms", form).removeClass('hidden').find('label span').addClass('hidden');
                            USER.send_sms('preorder', form);
                            $("[type=submit]", form).html(__('Продовжити')).data('to', 'checksms');
                            break;
                    }
                }
            }
        });

        jQuery("body").on("click", ".workdrawer-check-availability form button", function (e) {
            e.preventDefault();
            let btn = $(this);
            let form = $(".form-checkav");
            let name = form.find('[name=name]').val();
            let phone = form.find('[name=login]').val();
            let sku = form.find('[name=sku]').val();

            if (btn.hasClass('active'))
                if ($.trim(sku) != '')
                    $.post(
                        '/u/checkavailability',
                        {
                            to: 'checkavailability',
                            name: name,
                            phone: phone,
                            sku: sku,
                            locale: G.locale_id
                        },
                        function (data) {
                            if (U.isMobile()) {
                                DRAWER.init('workdrawer-writemain_thx workdrawer-full', {
                                    action: 'popup',
                                    to: 'checkavthx'
                                });
                            } else {
                                DRAWER.destroy();
                                short_popup(data.html);
                            }
                        },
                        'json'
                    );

            return;
        });

        jQuery("body").on("click", ".cart-tabs a", function (e) {
            e.preventDefault();
            var btn = $(this);
            var self = btn.parent().hasClass('active') ? true : false;
            var container = btn.parents('.scroll');
            container.find(".cart-tabs li, .cart-tabs-content >div").removeClass('active');

            if (!self) {
                btn.parent().addClass('active');
                container.find(".cart-tabs-content [data-tab=" + btn.data('toggle') + "]").addClass('active');
            }
        });

        jQuery("body").on("click", ".cart-tabs-content >div >.close-tab", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".cart-tabs li.active a").trigger('click');
        });

        if (!Cookies.get("ccnt"))
            CARD.recount();

        // Отмена заявки монобанка
        jQuery("body").on("click", ".monobank_cancel", function (e) {
            e.preventDefault();

            clearTimeout(CARD.monobank_timeout_handler);

            $.post(
                '/aj',
                {
                    action: 'basket',
                    locale: G.locale_id,
                    to: 'cancel_monobank'
                },
                function (data) {
                    $(".cart").removeClass('monobank');
                    $(".monobank-approve-form").remove();
                    CARD.removePaymentStep();
                    CARD.go_step(3);
                },
                'json'
            );
        });

        // Отмена заявки А-банка
        jQuery("body").on("click", ".abank_cancel", function (e) {
            e.preventDefault();

            clearTimeout(CARD.monobank_timeout_handler);

            $.post(
                '/aj',
                {
                    action: 'basket',
                    locale: G.locale_id,
                    to: 'cancel_abank'
                },
                function (data) {
                    $(".cart").removeClass('abank');
                    $(".abank-approve-form").remove();
                    CARD.removePaymentStep();
                    CARD.go_step(3);
                },
                'json'
            );
        });

        // Отмена заявки А-банка
        jQuery("body").on("click", ".payparts_cancel", function (e) {
            e.preventDefault();

            clearTimeout(CARD.monobank_timeout_handler);

            $.post(
                '/aj',
                {
                    action: 'basket',
                    locale: G.locale_id,
                    to: 'cancel_payparts'
                },
                function (data) {
                    $(".cart").removeClass('payparts');
                    $(".payparts-approve-form").remove();
                    CARD.removePaymentStep();
                    CARD.go_step(3);
                },
                'json'
            );
        });

        // Отмена заявки portmone
        jQuery("body").on("click", ".js-portmone_cancel", function (e) {
            e.preventDefault();

            clearTimeout(CARD.monobank_timeout_handler);

            $.post(
                '/aj',
                {
                    action: 'basket',
                    locale: G.locale_id,
                    to: 'cancel_portmone'
                },
                function (data) {
                    $(".cart").removeClass('abank');
                    $(".portmone-approve-form").remove();
                    CARD.removePaymentStep();
                    CARD.go_step(3);
                },
                'json'
            );
        });

        // выбор кредитной группы buy-in-credit
        jQuery("body").on("click", ".bc__creditlist >div", function (e) {
            e.preventDefault();
            var btn = $(this);

            if (!btn.hasClass('active')) {
                btn.parent().find('>.active .bc__selection.opened').removeClass('opened');
                btn.parent().find('>.active').removeClass('active');
                btn.addClass('active');
            }

            CARD.select_bc_method(btn.find('.bc__selection >.active'));
        });

        // выбор платежного метода онлайн
        jQuery("body").on("click", ".bc__selection.opened >div", function (e) {
            e.preventDefault();
            var btn = $(this);
            var container = btn.parents('.bc__creditdata').parent();
            $(".bc__selection.opened").removeClass('opened');
            btn.parent().find('.active').removeClass('active');
            btn.addClass('active');
            container.parent().find('>.active').removeClass('active');
            container.addClass('active').find('.bc__price').html('<small>по</small> ' + btn.data('nextpay') + ' грн');
            container.find('.bc__monthssuffix').html(btn.data('suffix'));

            CARD.select_bc_method(btn);

        });

        // выбор платежного метода онлайн
        jQuery("body").on("click", ".bc__selection:not(.opened)", function (e) {
            e.preventDefault();
            $(".bc__selection.opened").removeClass('opened');
            $(this).toggleClass('opened');
        });

        jQuery("body").on("click", ".bc__selection.opened", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".bc__selection.opened").removeClass('opened');
        });

        // выбор платежного метода онлайн
        jQuery("body").on("click", ".bc__submit [type=submit]", function (e) {
            e.preventDefault();
            let btn = $(this);

            if (btn.hasClass('active') && !btn.hasClass('loading')) {
                btn.addClass('loading');
                CARD.add_buy_in_credit($(".workdrawer-buy-in-credit input[name=sku]").val(), $(".workdrawer-buy-in-credit input[name=bcmethod]").val());
            }
        });

        // поиск компании
        jQuery("body").on("click", ".js-cart__opensearchcompany", function (e) {
            e.preventDefault();
            SEARCHCOMPANY.toggle_search_form(true);
        });

        // выбор компании
        jQuery("body").on("click", ".js-cart__searchcompanyitem", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let item = $(this);
            let was = item.find('input').prop('checked');

            if (was) {
                SEARCHCOMPANY.remove_company();
            } else {
                SEARCHCOMPANY.select(item);
            }
        });

        // сброс выбора компании
        jQuery("body").on("click", ".js-cart__searchcompanyremove", function (e) {
            e.preventDefault();
            SEARCHCOMPANY.remove_company();
        });

        // keydown
        jQuery("body").on("keydown", ".cart__searchcompany [name=searchcompany]", function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                $(".cart__searchcompany [name=searchcompany]").trigger('keyup');
                return;
            }
        });

        // keyup
        jQuery("body").on("click", ".js-cart__searchcompany", function (e) {
            e.preventDefault();
            e.stopPropagation();
            SEARCHCOMPANY.search_company(false);
        });

        // keyup
        jQuery("body").on("keyup", ".cart__searchcompany [name=searchcompany]", function (e) {
            let use_timeout = true;

            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                use_timeout = false;
            }

            $(".cart__searchcompanyresults .alert").addClass('hidden');
            SEARCHCOMPANY.search_company(use_timeout);
            return false;
        });

        // open predefined
        jQuery("body").on("focus", ".cart__searchcompany [name=searchcompany]", function (e) {
            e.preventDefault();
            SEARCHCOMPANY.toggle_predefined(true);
        });

        // open add company form
        jQuery("body").on("click", ".js-cart__openaddcompany, .js-cart__opensearchcompany", function (e) {
            e.preventDefault();
            e.stopPropagation();
            SEARCHCOMPANY.toggleCompanyAddForm($(this).hasClass('js-cart__openaddcompany'));
            return false;
        });

        // open add company form
        jQuery("body").on("keyup", "[name=searchcompany_address], [name=searchcompany_edrpou]", function (e) {
            let input = $(this);
            CARD.possible_submit_pay();
            input.parent().find('label').addClass('hidden');

            if (input.attr('name') == 'searchcompany_address')
                CARD.searchcompany_address = input.val();
            else
                CARD.searchcompany_edrpou = input.val();
        });

        // open predefined
        jQuery("body").on("click", ".cart__searchcompanypredefined-toggle", function (e) {
            e.preventDefault();
            SEARCHCOMPANY.toggle_predefined(false);
        });

        // open predefined
        jQuery("body").on("click", ".js-cart__companymoreresults", function (e) {
            e.preventDefault();
            SEARCHCOMPANY.show_more();
        });

        // check, switch company type
        jQuery("body").on("click", ".js-switch__companytype", function (e) {
            e.preventDefault();
            SEARCHCOMPANY.switch_register_form($(this).data('to'));
        });

        // another recipient
        jQuery("body").on('click', '.js-cart__anotherrecipientopen, .js-cart__anotherrecipientclose', function (e) {
            e.preventDefault();
            ANOTHERRECIPIENT.toggle();
        });

        // recipient keyup
        jQuery("body").on("keyup", ".cart__anotherrecipient [name=anotherrecipient_phone], .cart__anotherrecipient [name=anotherrecipient_name], .cart__anotherrecipient [name=anotherrecipient_first_name], .cart__anotherrecipient [name=anotherrecipient_last_name]", function (e) {
            CARD.possible_submit_delivery();
        });

        jQuery("body").on("click", ".js-cart__itemupsalebtn", function (e) {
            e.preventDefault();
            CARD.load_upsale_window($(this).parents('.cart__item').data('sku'));
        });

        if (U.isMobile()) {
            jQuery("body").on("swipeleft", ".cart__item", function (e) {
                e.preventDefault();
                $(".cart__title").html('swipe');
                CARD.load_upsale_window($(this).data('sku'));
            });
        }

        // акси
        jQuery("body").on("click", ".js-cart__accschangetab", function (e) {
            e.preventDefault();
            let btn = $(this);
            CARD.load_upsale_tab($(".cart__upsale [name=sku]").val(), btn);
        });

        // bonus
        jQuery("body").on("click", ".js-cart__usebonus", function (e) {
            e.preventDefault();
            let btn = $(this);

            if (btn.hasClass('active')) {
                btn.removeClass('active');
                $(".cart__usebonusamount").addClass('hidden');
                CARD.bonus_opened = false;
            } else {
                btn.addClass('active');
                $(".cart__usebonusamount").removeClass('hidden');
                CARD.bonus_opened = true;
            }
        });

        jQuery("body").on("keydown", ".js-input__forcemax", function (e) {
            let el = $(this);

            console.log(el);
            if (!el.val() || (parseInt(el.val()) <= el.data('max') && parseInt(el.val()) >= el.data('min')))
                el.data("old", el.val());
        });

        jQuery("body").on("keyup", ".js-input__forcemax", function (e) {
            let el = $(this);
            // Check correct, else revert back to old value.
            if (!el.val() || (parseInt(el.val()) <= el.data('max') && parseInt(el.val()) >= el.data('min'))) {
                el.val(parseInt(el.val()));
            } else {
                el.val(el.data("old"));
            }

            CARD.bonuses_entered = el.val();
            CARD.set_cart_total();
        });

        jQuery("body").on("click", ".js-cart__payedilo", function (e) {
            e.preventDefault();
            let el = $(this);

            const price = parseInt(CARD.sum.uah * 1.06);

            showEdiloForm({
                "edilo_amount": price, // * required
                "edilo_phone": CARD.user_data.phone,
                "edilo_email": CARD.user_data.email,
                "edilo_full_name": CARD.user_data.name,
                "edilo_goods": CARD.current_data.map(item => {
                    return {
                        "name": item.name,
                        "quantity": item.quantity,
                        "code": item.id
                    };
                })
            });
        });

        document.addEventListener('edilo_result', function (event) {
            console.log(event);

            if (CARD.opened()) {
                if (event.detail.status=='success') {
                    CARD.postData({
                        action: 'basket',
                        to: 'saveediloresult',
                        edilo_data: JSON.stringify(event.detail.data)
                    }).then(() => {
                        CARD.show_thx(CARD.lead_id);
                    })
                } else {
                    // show_error
                }
            } else {
                GTM.fireStatistick('statistick', 'click', 'Відправлена форма eDilo', event.detail.data.appID);
            }         

            return;
        }, false);

        jQuery("body").on("click", ".js-monocheckout__btn", function (e) {
            e.preventDefault();
            let el = $(this);

            if (el.hasClass('monocheckout__btn-loading'))
                return;

            el.addClass('monocheckout__btn-loading');

            GTM.fireStatistick('statistick', 'click', 'order_click_mono', '');

            CARD.postData({
                action: 'basket',
                to: 'send_monocheckout',
            }).then(e => {
                if (e.success) {
                    document.location.assign(e.redirect_url);
                } else {
                    $(".js-monocheckout__alert").removeClass('hidden').html(e.error);
                }
            }).catch(e => {
                $(".js-monocheckout__alert").removeClass('hidden').html('Помилка при створенні замовлення');
            }).finally(() => {
                el.removeClass('monocheckout__btn-loading')
            });
        });

    });
}

export const SEARCHCOMPANY = {

    total: 0,

    switch_register_form: function(to) {
        $(".js-switch__companytype").removeClass('active');
        $(".js-switch__companytype[data-to=" + to + "]").addClass('active');

        if (to=='fop') {
            $("[name=searchcompany_edrpou]").attr('placeholder', 'РНОКПП (ІПН)').data('limit', 10).attr('maxlength', 10);
            $("[name=searchcompany_address]").attr('placeholder', 'ПІБ');
            CARD.searchcompany_type = 'fop';
        } else {
            $("[name=searchcompany_edrpou]").attr('placeholder', 'ЄДРПОУ').data('limit', 8).attr('maxlength', 8);
            $("[name=searchcompany_address]").attr('placeholder', 'Назва компанії');
            CARD.searchcompany_type = 'UO';
        }
    },

    toggle_predefined: function(hide = true) {
        if (hide) {
            if ($(".cart__searchcompanypredefined label").length > 1) {
                $(".cart__searchcompanypredefined").addClass('hidden');
                if ($(".cart__searchcompanypredefined-toggle").length == 0) {
                    $('<a href="javascript: void(null);" class="cart__searchcompanypredefined-toggle">Мої компанії <small>' + $(".cart__searchcompanypredefined label").length + '</small></a>').insertAfter(".cart__searchcompanypredefined");
                }
            }
        } else {
            $(".cart__searchcompanypredefined").removeClass('hidden');
            $(".cart__searchcompanypredefined-toggle").remove();
        }
    },

    select: function(item) {
        item.removeClass('checkbox-linebottom').parent().find('>label:not(.radiobox-predefined)').not(item).remove();
        item.removeClass('checkbox-linebottom').parent().find('>label').not(item).addClass('hidden');

        $(".cart__searchcompanyresultslist >label").not(item).remove();
        $(".cart__searchcompanyresultstotal").remove();

        $(".cart__searchcompanyform").addClass('hidden');
        $(".cart__searchcompanyresults").addClass('cart__searchcompanyresults-active');
        $(".cart__searchcompanyselected").removeClass('hidden');

        CARD.save_fields('', '', {
            edrpou: item.find('input[type=checkbox]').val(),
            contractor: item.find('input[type=hidden]').length > 0 ? item.find('input[type=hidden]').val() : ''
        });

        item.find('input').prop('checked', true);
        this.toggleContractorForm(false);
        CARD.possible_submit_pay();

        if (!item.parent().hasClass('cart__searchcompanypredefined'))
            $(".cart__searchcompanypredefined").addClass('hidden');
    },

    toggleContractorForm: function(show = true) {
        if (show)
            $(".cart__contractorform").removeClass('hidden');
        else
            $(".cart__contractorform").addClass('hidden');
    },

    toggleCompanyAddForm: function(show = true) {
        // $(".cart__searchcompanyaddform input, .cart__searchcompanyaddform textarea").trigger('reset');
        //
        // CARD.searchcompany_address = '';
        // CARD.searchcompany_edrpou = '';

        $(".js-cart__searchcompanyitem input").prop('checked', false);
        if (show) {
            $(".cart__searchcompanyaddform").removeClass('hidden');
            $(".js-cart__opensearchcompany").removeClass('hidden');
            $(".js-cart__openaddcompany").addClass('hidden');
            $(".cart__searchcompanytop").addClass('hidden');
            $(".cart__searchcompanyaddbutton").addClass('hidden');
        }
        else {
            $(".cart__searchcompanyaddform").addClass('hidden');
            $(".js-cart__opensearchcompany").addClass('hidden');
            $(".js-cart__openaddcompany").removeClass('hidden');
            $(".cart__searchcompanytop").removeClass('hidden');
            $(".cart__searchcompanyaddbutton").removeClass('hidden');
        }

        CARD.save_fields('', '', {
            edrpou: '',
            contractor: ''
        });

        CARD.possible_submit_pay();
    },

    remove_company: function() {
        $(".js-cart__searchcompanyitem input").prop('checked', false);
        this.clear_results();
        $(".cart__searchcompanyresults .alert").addClass('hidden');
        $(".cart__searchcompanyform").removeClass('hidden');
        $(".cart__searchcompanyselected").addClass('hidden');
        $(".js-cart__searchcompany").trigger('click');
        $(".cart__searchcompanypredefined >label").removeClass('hidden');
        $(".cart__searchcompanypredefined").removeClass('hidden');

        CARD.save_fields('', '', {
            edrpou: '',
            contractor: ''
        });

        this.toggleContractorForm(true);
        this.toggleCompanyAddForm(false);
        CARD.possible_submit_pay();

        // clear lines
        $(".cart__searchcompanypredefined >label").addClass('radiobox-predefined');
        $(".cart__searchcompanypredefined >label:last-child").removeClass('radiobox-predefined');
    },

    result_count_title: function() {
        let showed = $(".cart__searchcompanyresultslist label:not(.hidden)").length;
        $(".cart__searchcompanyresultstotal").remove();
        $(".cart__searchcompanyresultslist").prepend('<div class="cart__searchcompanyresultstotal">Показано ' + showed + ' з ' + (this.total==10000 ? 'понад 10000' : this.total) + ' результатів</div>');
    },

    fill: function(data) {
        this.clear_results();
        this.total = data.total;
        let counter = 0;

        data.result.forEach((item) => {
            counter++;

            $(".cart__searchcompanyresultslist").append('<label class="radiobox checkbox-linebottom js-cart__searchcompanyitem ' + (counter > 5 ? 'hidden' : '') + '">' +
                '<input type="checkbox" name="edrpou" value="' + item.edrpou + '" />' +
                '<div class="checkbox__title">' + item.name + '</div>' +
                '<div class="checkbox__havent">ЕДРПОУ: ' + item.edrpou + '</div>' +
                '<div class="checkbox__sub">' + item.address + '</div>' +
                '</label>');
        });

        this.result_count_title();

        $(".cart__searchcompanyresultslist .radiobox:last-child").removeClass('checkbox-linebottom');
        $(".cart__searchcompanyresults .alert").addClass('hidden');

        this.more_button();

        // scroll
        let scroll_value = $(".cart .checkout").scrollTop() +$(".cart__searchcompanyform").offset().top - 50;
        $(".cart .checkout").animate({scrollTop: scroll_value}, '100', 'swing');
    },

    more_button: function() {
        // show more button
        if ($(".cart__searchcompanyresultslist label.hidden").length > 0) {
            $(".cart__searchcompanyaddbutton").addClass('cart__searchcompanyaddbutton-wide');
            $(".js-cart__companymoreresults").removeClass('hidden');
        } else {
            $(".cart__searchcompanyaddbutton").removeClass('cart__searchcompanyaddbutton-wide');
            $(".js-cart__companymoreresults").addClass('hidden');
        }
    },

    show_more: function() {
        if ($(".cart__searchcompanyresultslist label.hidden").length > 0) {
            let counter = 0;

            $.each($(".cart__searchcompanyresultslist label.hidden"), function(i, item) {
                counter++;

                if (counter <= 10) {
                    $(item).removeClass('hidden');
                }
            });
        }

        if ($(".cart__searchcompanyresultslist label.hidden").length==0) {
            $(".js-cart__companymoreresults").addClass('hidden');
        }

        this.result_count_title();
        this.more_button();
    },

    search_company: function(use_timeout = true) {
        let input = $(".cart__searchcompany [name=searchcompany]");
        let val = $.trim(input.val());
        input.removeClass('form__input-loading');
        clearTimeout(CARD.novaposhta_timeout_handler);

        if (val.length > 2) {
            CARD.novaposhta_timeout_handler = setTimeout(function () {
                input.addClass('form__input-loading');
                SEARCHCOMPANY._search_company(val)
                    .then((result) => {
                        SEARCHCOMPANY.fill(result);
                    })
                    .catch(() => {
                        $(".cart__searchcompanyresultslist").addClass('hidden');
                        $(".cart__searchcompanyresults .alert").removeClass('hidden');
                    })
                    .finally(() => {
                        $(".cart__searchcompanyresults").removeClass('hidden');
                        input.removeClass('form__input-loading');

                        // hide add company form
                        $(".cart__searchcompanyaddform").addClass('hidden');
                    });
            }, use_timeout ? 500 : 1);
        }

        if (val.length == 0 && use_timeout) {
            this.clear_results();
        }
    },

    clear_results: function() {
        $(".cart__searchcompanyresultslist .radiobox:not(.radiobox-predefined)").remove();
        $(".cart__searchcompanyresultslist .radiobox").removeClass('hidden').addClass('checkbox-linebottom');
        $(".cart__searchcompanyresultslist").removeClass('hidden');
        $(".cart__searchcompanyresultstotal").remove();
    },

    _search_company: function(value) {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "POST",
                url: "/aj",
                data: {
                    action: 'basket',
                    to: 'searchcompany',
                    query: value
                },
                dataType: "json",
                timeout: 30000, // in milliseconds
                success: function(data) {
                    if (data.result.length > 0)
                        resolve(data);
                    else
                        reject({
                            total: 0,
                            result: []
                        });
                },
                error: function(data) {
                    reject([]);
                }
            });
        });
    },

    toggle_search_form: function(show = true) {
        this.toggleContractorForm(false);
    }

}

export const ANOTHERRECIPIENT = {
    toggle: function() {
        $(".js-cart__anotherrecipientopen").toggleClass('hidden');
        $(".cart__anotherrecipient").toggleClass('hidden');

        let delivery_method = $(".delivery__method.active input").val();

        if (delivery_method=='novaposhtac') {
            $(".js-anotherrecipient__lastname2").removeClass('hidden');
        } else {
            $(".js-anotherrecipient__lastname2").addClass('hidden');
        }

        CARD.possible_submit_delivery();
    },

    error_text: function() {
        let text = '';

        if (this.is_exists()) {
            if (!this.check_first_name()) {
                text = 'Заповніть прізвище українською';
            }

            if (!this.check_last_name()) {
                text = 'Заповніть ім\'я українською';
            }

            if (!this.check_last_name2()) {
                text = 'Заповніть по батькові';
            }

            if (!this.check_phone()) {
                text = 'Номер телефону іншого отримувача обов\'язковий для заповнення';
            }

            if (!this.check_valid_phone_number()) {
                text = 'Введіть номер телефону в правильному форматі.';
            }

            // console.log('this.check_first_name()', this.check_first_name());
            // console.log('this.check_last_name()', this.check_last_name());
            // console.log('this.check_phone()', this.check_phone());
            // console.log('text', text);
        }

        return text;
    },

    check_valid_phone_number: function() {
        let phone = $(".cart__anotherrecipient [name=anotherrecipient_phone]").val();
        phone = phone.replace(/\D/g,'');
        return USER.codeAllowed(phone);
    },

    trigger_show: function() {
        let show = $(".delivery__methods .delivery__method.active").length > 0 ? $(".delivery__methods .delivery__method.active").data('another_recipient') : false;

        if (this.valid()) {
            $(".js-cart__anotherrecipientopen").addClass('hidden');
            $(".cart__anotherrecipient").removeClass('hidden');
        } else {
            if (show) {
                $(".js-cart__anotherrecipientopen").removeClass('hidden');
            } else {
                $(".js-cart__anotherrecipientopen").addClass('hidden');
            }

            $(".cart__anotherrecipient").addClass('hidden');
        }
    },

    showed: function() {
        return !$(".cart__anotherrecipient").hasClass('hidden');
    },

    regEx: /^[а-яА-ЯЄєйЙїЇіІьЬ\s\'\"\'\`]*$/i,

    check_name: function() {
        let name = $(".cart__anotherrecipient [name=anotherrecipient_name]").val();
        let words = name.split(' ').filter((name) => $.trim(name).length >= 2);
        let check_words_count = $(".selected-method:not(.hidden) .for-house").length > 0 ? 3 : 2;
        return (this.regEx.test(name) && words.length >= check_words_count);
    },

    check_first_name: function() {
        let name = $.trim($(".cart__anotherrecipient [name=anotherrecipient_first_name]").val());
        let words = name.split(' ').filter((name) => $.trim(name).length >= 2);
        return (this.regEx.test(name) && words.length==1);
    },

    check_last_name: function() {
        let name = $.trim($(".cart__anotherrecipient [name=anotherrecipient_last_name]").val());
        let words = name.split(' ').filter((name) => $.trim(name).length >= 2);
        return (this.regEx.test(name) && words.length==1);
    },

    check_last_name2: function() {
        let delivery_method = $(".delivery__method.active input").val();

        if (delivery_method=='novaposhtac') {
            let name = $.trim($(".cart__anotherrecipient [name=anotherrecipient_last_name2]").val());
            let words = name.split(' ').filter((name) => $.trim(name).length >= 2);
            return (this.regEx.test(name) && words.length==1);
        } else {
            return true;
        }
    },

    check_phone: function() {
        let phone = $(".cart__anotherrecipient [name=anotherrecipient_phone]").val();
        return phone.replace(/\D/g,'').length==10 ? true : false;
    },

    valid: function() {
        return this.is_exists() && this.check_first_name() && this.check_last_name() && this.check_last_name2() && this.check_phone() && this.check_valid_phone_number();
    },

    is_exists: function() {
        return $(".cart__anotherrecipient").length > 0;
    },

    get_name: function() {
        return $(".cart__anotherrecipient").hasClass('hidden') ? '' : $.trim(`${$(".cart__anotherrecipient [name=anotherrecipient_first_name]").val()} ${$(".cart__anotherrecipient [name=anotherrecipient_last_name]").val()} ${$(".cart__anotherrecipient [name=anotherrecipient_last_name2]").val()}`);
    }
}